export const contentSpanish = {
  code: "ES",
  labels: {
    // App Digital Admin
    digitalAdmin: "Digital Admin",
    digitalAdminApp: "App Digital Admin",
    digitalAdminPro: "Digital Admin Pro",
    digitalAdminSarl: "Digital Admin SARL",
    copilotTitle: "Digital Copilot",
    copilotComingSoon: "Su asistente IA llega pronto",
    copilotOpen: "Abrir Copilot",
    copilotClose: "Cerrar Copilot",
    copilotPlaceholder: "Haga una pregunta a su asistente IA",
    copilotInputPlaceholder: "Escriba su mensaje...",
    copilotSend: "Enviar",
    copilotConnected: "Conectado",
    copilotConnecting: "Conectando...",
    copilotDisconnected: "Desconectado",
    copilotConnectionLost: "Conexion perdida",
    copilotReconnect: "Reconectar",
    copilotToolRunning: "Buscando",
    copilotActionProposed: "Accion propuesta",
    copilotConfirm: "Confirmar",
    copilotReject: "Rechazar",
    copilotConfirming: "Confirmando...",
    copilotRejecting: "Rechazando...",
    copilotActionBlockInput: "Confirme o rechace la accion propuesta para continuar",
    copilotActionHint: "Confirme, rechace o escriba una correccion",
    copilotActionCreateContact: "Nuevo contacto",
    copilotActionCreateInvoice: "Nueva factura de cliente",
    copilotActionCreateQuote: "Nuevo presupuesto",
    copilotActionCreateOrder: "Nuevo pedido de cliente",
    copilotActionCreateProviderInvoice: "Nueva factura de proveedor",
    copilotActionCreateProviderOrder: "Nuevo pedido de proveedor",
    copilotActionCreateExpense: "Nuevo gasto",
    copilotActionCreateAccountingEntry: "Nuevo asiento contable",
    copilotResultContactCreated: "Contacto creado",
    copilotResultInvoiceCreated: "Factura de cliente creada",
    copilotResultQuoteCreated: "Presupuesto creado",
    copilotResultOrderCreated: "Pedido de cliente creado",
    copilotResultProviderInvoiceCreated: "Factura de proveedor creada",
    copilotResultProviderOrderCreated: "Pedido de proveedor creado",
    copilotResultExpenseCreated: "Gasto creado",
    copilotResultAccountingEntryCreated: "Asiento contable creado",
    copilotResultGeneric: "Accion completada",
    copilotResultFailed: "La accion ha fallado",
    copilotDiscussDocument: "Discutir con el Copilot",
    copilotDocumentAttached: "Documento adjunto",
    copilotDetachDocument: "Desadjuntar",
    copilotViewPiece: "Ver el documento",
    copilotAttachDocument: "Adjuntar un documento",
    copilotSearchExisting: "Buscar existente",
    copilotUploadNew: "Subir nuevo",
    copilotSearchPlaceholder: "Buscar por nombre...",
    copilotUploading: "Subiendo...",
    copilotUploadError: "Error al subir",
    copilotNoDocuments: "No se encontraron documentos",
    uploadingFile: "Subiendo archivo...",
    uploadProgress: "Progreso de subida",
    zipExtractionStarted: "Extraccion ZIP iniciada",
    zipExtractionInProgress: "Su archivo ZIP se esta extrayendo en segundo plano. Los documentos apareceran en breve.",
    uploadFailed: "Error al subir",
    uploadTooLarge: "El archivo supera el tamano maximo permitido",
    copilotOnline: "En linea",
    copilotYou: "Tu",
    copilotHistory: "Historial",
    copilotNewConversation: "Nueva conversacion",
    copilotNoThreads: "Sin conversaciones",
    copilotActionRejected: "Accion rechazada",
    copilotActionFailedPast: "Accion fallida",
    copilotLoadingMessages: "Cargando mensajes...",
    copilotSuggestCreateExpense: "Crear un gasto",
    copilotSuggestCreateProviderInvoice: "Crear una factura de proveedor",
    copilotSuggestMsgCreateExpense: "Crea un gasto a partir del documento adjunto.",
    copilotSuggestMsgCreateProviderInvoice: "Crea una factura de proveedor a partir del documento adjunto.",
    copilotActionStartBatch: "Procesamiento por lotes",
    copilotBatchConfirmText: "Procesar automáticamente todos los documentos pendientes. El copiloto analizará y creará las entradas correspondientes.",
    copilotBatchMilestone: "Procesamiento por lotes",
    copilotSuggestProcessDocuments: "Procesar mis documentos",
    copilotSuggestMsgProcessDocuments: "Procesa automáticamente todos mis documentos pendientes.",
    viewDocument: "Ver documento",
    welcomeToDigitalAdmin: "Bienvenido a Digital Admin",
    purchasePro: "Comprar Digital Admin Pro",
    signIn: "Iniciar sesión en Digital Admin",

    // Words sentences
    about: "Acerca de",
    successful: "Con éxito",
    error: "Error",
    accountSettings: "Configuración de la cuenta",
    actions: "Acciones",
    additional: "Adicional",
    address: "Dirección",
    administrativeArea: "Cantón",
    amount: "Cantidad",
    sum: "Suma",
    amountTotal: "Monto total",
    apply: "Aplicar",
    approved: "Aprobado",
    ascending: "Ascendente",
    addContact: "Agregar contacto",
    addContent: "Agregar contenido",
    addSignature: "Agregar firma",
    avatar: "Avatar",
    back: "Atras",
    bban: "BBAN",
    bicSwift: "BIC/SWIFT",
    bimester: "Bimestre",
    calculatedValuesAreReferential: "Los valores calculados son referenciales",
    cancel: "Cancelar",
    canceled: "Cancelada",
    city: "Ciudad",
    comment: "Comentario",
    completed: "Completado",
    companyContact: "Contacto de la empresa",
    content: "Contenido",
    registerNumber: "Numero de registro",
    concerning: "Asunto",
    contactInformation: "Información del contacto",
    continue: "Continuar",
    country: "País",
    create: "Crear",
    createdDate: "Fecha de creación",
    currency: "Moneda",
    customer: "Cliente",
    date: "Fecha",
    day: "Día",
    days: "Días",
    default: "Predeterminada",
    delete: "Eliminar",
    descending: "Descendente",
    description: "Descripción",
    detail: "Detalle",
    details: "Detalles",
    discard: "Descartar",
    doNotGroup: "No agrupar",
    edit: "Editar",
    email: "Correo electrónico",
    end: "Fin",
    endDate: "Fecha de finalización",
    excel: "Excel",
    export: "Exportar",
    filter: "Filtros",
    filterOptions: "Opciones de filtro",
    firstName: "Nombres",
    group: "Grupo",
    halfYear: "Medio año",
    iban: "IBAN",
    identity: "Identidad",
    inProgress: "En progreso",
    justNow: "Justo ahora",
    lastDay: "Último día",
    lastName: "Apellidos",
    legalInformation: "Información legal",
    list: "Listar",
    location: "Ubicación",
    menu: "Menú",
    message: "Mensaje",
    messages: "Mensajes",
    archived: "Archivados",
    read: "Leidos",
    unread: "No leidos",
    archive: "Archivar",
    noNumber: "Sin número",
    noMatchingRecordsFound: "No se encontraron registros coincidentes",
    month: "Mes",
    months: "Meses",
    number: "Número",
    sortAlphabetically: "Ordenar alfabéticamente",
    pages: "Páginas",
    pdf: "PDF",
    pending: "Pendiente",
    person: "Persona",
    phone: "Teléfono",
    phoneNumber: "Número de teléfono",
    priceGross: "Precio bruto",
    priceNet: "Precio neto",
    priceTotal: "Precio total",
    product: "Producto",
    products: "Productos",
    qrIban: "QR-IBAN",
    quantity: "Cantidad",
    stockLimitReached: "Límite de stock alcanzado",
    lowStockWarning: "Advertencia de stock bajo",
    accepted: "Aceptado",
    declined: "Rechazado",
    rejected: "Rechazado",
    sent: "Enviado",
    remove: "Remover",
    removeReference: "Eliminar referencia",
    removeContent: "Eliminar contenido",
    removeSignature: "Eliminar firma",
    removeRequirement: "Eliminar bloque",
    removeVoucher: "Eliminar comprobante",
    requirement: "Bloque",
    requirements: "Bloques",
    reset: "Restablecer",
    saveChanges: "Guardar cambios",
    searchResults: "Resultados de búsqueda",
    selectExportFormat: "Seleccionar formato de exportación",
    send: "Enviar",
    service: "Servicio",
    services: "Servicios",
    appService: "Servicio de la aplicacion",
    appServices: "Servicios de la aplicacion",
    signature: "Firma",
    signatures: "Firmas",
    start: "Inicio",
    startDate: "Fecha de inicio",
    status: "Estado",
    street: "Calle",
    subTotal: "Subtotal",
    support: "Soporte",
    symbol: "Símbolo",
    tax: "Impuesto",
    taxSale: "Impuesto en venta",
    taxPurchase: "Impuesto en compra",
    taxRate: "Tasa impositiva",
    taxTotal: "Total de impuestos",
    trimester: "Trimestre",
    total: "Total",
    totalAmount: "Monto total",
    top: "Top",
    type: "Tipo",
    timeInterval: "Intervalo de tiempo",
    interval: "Intervalo",
    unitMeasure: "Unidad de medida",
    unitPrice: "Precio unitario",
    update: "Actualizar",
    validity: "Validez",
    value: "Valor",
    vatNumber: "Número VAT/IDE",
    contactCode: "Código de contacto",
    webSite: "Sitio de internet",
    week: "Semana",
    weeks: "Semanas",
    view: "Ver",
    yes: "Si",
    zipCode: "Código postal",
    gross: "Bruto",
    net: "Neto",
    rebate: "Rebaja",
    rebateTotal: "Total de rebaja",
    selectOptionAddAmountPercentageDesired: "Seleccione una opción y agregue la cantidad o porcentaje deseado",
    changeImage: "Cambiar imagen",
    changeLogo: "Cambiar logotipo",
    exportError: "Error al exportar",
    failedToLoadTheScript: "No se pudo cargar el script",
    identificationNumberForACompany: "Número de identificación de una empresa que desea realizar operaciones a nivel europeo",
    internationalBankAccountNumberIban: "Número de cuenta bancaria internacional (IBAN)",
    listOfCompaniesIHaveAccess: "Lista de empresas a las que tengo acceso",
    noRecordsFound: "No se encontraron registros",
    noResultsFound: "No se encontraron resultados",
    companyNotSubjectToVat: "Sin declaraciones de IVA",
    companyNotSubjectToVatDescription: "Esta empresa no está sujeta al IVA. No hay periodos de declaración disponibles.",
    removeImage: "Remover imagen",
    selectTheTypeOfContact: "Seleccione el tipo de contacto que desea crear",
    specifyTheUniqueUUID: "Especifique el código UUID único de un usuario o empresa",
    theDefaultBankAccountIsTheCompanys: "La cuenta de tesorería predeterminada es la de la empresa",
    theDefaultCurrencyIsTheCompanys: "La moneda predeterminada es la de la empresa",
    theDefaultShapeOrVersionOfAQrInvoiceToDownloadIsTheClients:
      "La forma o versión predeterminada de una factura QR para descargar es la del cliente",
    theDefaultLanguageToDownloadIsTheClients: "El idioma predeterminado para descargar es el del cliente",
    youMustAcceptTheTermsAndConditions: "Debe aceptar los términos y condiciones",
    acceptingInvitationToAccessCompany: "Aceptando la invitación para acceder a la empresa",
    verificationYourAccount: "Verificación de su cuenta",
    addCompany: "Agregar empresa",
    allInLicense: "Licencia completa",
    buyNow: "Comprar ahora",
    comingSoon: "Próximamente",
    licenseTerms: "Términos de licencia",
    pageNotFound: "Página no encontrada",
    viewInvitations: "Ver invitaciones",
    purchase: "Comprar",
    reload: "Recargar",
    systemError: "Error del sistema",
    dashboard: "Dashboard",
    abbreviation: "Abreviatura",
    amountPurchases: "Monto de compras",
    amountSales: "Monto de ventas",
    best: "Mejor",
    companyInsight: "Perspectiva de la empresa",
    comparativeInterval: "Intervalo de comparación",
    comparisonIncomeAndExpenses: "Comparación de ingresos & gastos",
    customerPayments: "Pagos del cliente",
    customRange: "Rango personalizado",
    debtPercent: "Deuda(%)",
    distributionOfQuotes: "Distribución de cotizaciones según su estado",
    distributionOfOrders: "Distribución de pedidos según su estado",
    expirationDate: "Fecha de vencimiento",
    creationDate: "Fecha de creación",
    invoicesStillToBePaid: "Facturas pendientes de pago",
    invoicesStillToBePaidByTheCustomer: "Facturas pendientes de pago por parte del cliente",
    invoicesWithMoreDebt: "Facturas con más deuda",
    ordersByState: "Pedidos por estado",
    ordersToBilled: "Pedidos a facturar",
    paidPercent: "Pagado(%)",
    percentage: "Porcentaje",
    quotesByState: "Cotizaciones por estado",
    quotesAccepted: "Cotizaciones aceptadas",
    quotesApproved: "Cotizaciones aprobadas",
    quotesToExpire: "Cotizaciones a expirar",
    retailAnalysisSample: "Muestra de análisis minorista",
    representationOfSalesAndPurchases: "Representación de las ventas y compras de una empresa por mes durante un año",
    salesVsPurchases: "Ventas vs Compras",
    thisBimester: "Este bimestre",
    thisTrimester: "Este trimestre",
    thisHalfYear: "Este medio año",
    thisMonth: "Este mes",
    thisWeek: "Esta semana",
    thisYear: "Este año",
    today: "Hoy",
    turnout: "Monto de facturas",
    viewAll: "Ver todo",
    worst: "Peor",
    yesterday: "Ayer",
    fixedAmount: "Monto fijo",
    discount: "Descuento",
    account: "Cuenta",
    changeEmail: "Cambiar correo electrónico",
    changePassword: "Cambiar contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    currentPassword: "Contraseña actual",
    emailAddress: "Dirección de correo electrónico",
    enterNewEmailAddress: "Ingrese una nueva dirección de correo electrónico",
    fullName: "Nombre completo",
    newPassword: "Nueva contraseña",
    pleaseCheckYourEmailInbox: "Por favor revise su bandeja de entrada de su correo electrónico",
    profileCompleation: "Perfil de finalización",
    profileDetails: "Detalles del perfil",
    signInMethod: "Método de inicio de sesión",
    updateEmail: "Actualizar correo electrónico",
    updatePassword: "Actualizar contraseña",
    updateUser: "Actualizar usuario",
    validateAccount: "Validar cuenta",
    viewUser: "Ver usuario",
    user: "Usuario",
    users: "Usuarios",
    confirmPassword: "Confirmar contraseña",
    createAnAccount: "Crear una cuenta",
    enterYourEmailToResetYourPassword: "Ingrese su correo electrónico para restablecer su contraseña",
    goToLoginPage: "Ir a la página de inicio de sesión",
    goToPreviousPage: "Ir a la página anterior",
    language: "Idioma",
    languages: "Idiomas",
    myProfile: "Mi perfil",
    notVerified: "No verificado",
    password: "Contraseña",
    resetPassword: "Reiniciar contraseña",
    signInHere: "Ingrese aquí",
    signOut: "Cerrar sesión",
    submit: "Enviar",
    userProfile: "Perfil de usuario",
    use8OrMoreCharacters: "Usa 8 o más caracteres con una combinación de letras (minúsculas y mayúsculas), números y símbolos",
    verified: "Verificado",
    welcome: "Bienvenido",
    company: "Empresa",
    companies: "Empresas",
    current: "Actual",
    addDeadlinePaymentParameter: "Agregar parámetro de pago de fecha límite",
    addFeatureParameter: "Agregar parámetro de característica",
    addImage: "Agregar imagen",
    addTax: "Agregar impuesto",
    addDeadline: "Agregar fecha límite",
    addFeature: "Agregar caracteristica",
    addTaxRateParameter: "Agregar parámetro de tasa de impuestos",
    addUnit: "Agregar unidad",
    addUnitMeasureParameter: "Agregar parámetro de medida de unidad",
    advanceSettings: "Configuración avanzada",
    aNewCompanyWillBeCreated: "Se creará una nueva empresa a partir de los datos ingresados",
    browseUsers: "Explorar usuarios",
    companyAddress: "Dirección de la empresa",
    companyAdvanceSettings: "Configuración avanzada de la empresa",
    companyDownloadSettings: "Configuración de descarga de la empresa",
    companyAccountingSettings: "Configuración de contabilidad de la empresa",
    companyGeneralSettings: "Configuración de parámetros generales de la empresa",
    companyInformationSettingGeneral: "Configuración de información general de la empresa",
    companyIdentity: "Identidad de la empresa",
    companyLogo: "Logotipo de la empresa",
    companyName: "Nombre de la empresa",
    legalForm: "Forma jurídica",
    legalFormSarl: "SRL (Sàrl)",
    legalFormSa: "SA",
    legalFormRi: "Empresa individual",
    legalFormSnc: "Sociedad colectiva (SNC)",
    legalFormCooperative: "Sociedad cooperativa",
    legalFormAssociation: "Asociación",
    legalFormFondation: "Fundación",
    legalFormAutre: "Otro",
    createCompany: "Crear empresa",
    createAndSave: "Crear & Guardar",
    newCompany: "Nueva empresa",
    designOfDocumentToDownloadQuotesAndInvoices: "Diseño de documento para descargar cotizaciones pedidos y facturas",
    downloadSettings: "Configuración de descarga",
    dueDates: "Fechas de vencimiento para el pago de una factura",
    editCompany: "Editar empresa",
    free: "Gratis",
    generalSettings: "Configuración general",
    helpPage: "Página de ayuda",
    image: "Imagen",
    inviteAccessCompany: "Invitar a acceder a la empresa",
    legal: "Legal",
    listUsers: "Lista de usuarios",
    logo: "Logotipo",
    name: "Nombre",
    new: "Nuevo",
    noResultFound: "No se encontraron resultados",
    overview: "Resumen",
    accountingSettings: "Configuración de contabilidad",
    pleaseTryAgainWithADifferentQuery: "Por favor inténtalo de nuevo con una consulta diferente",
    predefinedTaxesFees: "Tasas de impuestos predefinidas",
    predefinedValues: "Valores predefinidos",
    freeInput: "Entrada libre",
    inputMethod: "Método de entrada",
    private: "Privado",
    removeLogo: "Eliminar logotipo",
    selectModel: "Seleccionar modelo",
    selectAndSaveDesiredLayoutToDownload: "Seleccione y guarde el diseño deseado para descargar la cotización, el pedido y la factura",
    selectAndSaveOneToFourDesiredColors:
      "Seleccione y guarde de uno a cuatro colores deseados para el diseño de cotizaciones, pedidos y facturas",
    sendInvitation: "Enviar invitación",
    settings: "Configuraciones",
    taxValue: "Valor fiscal",
    templateColors: "Colores de plantilla",
    templateModel: "Modelo de plantilla",
    unitsOfMeasure: "Unidades de medida para un servicio o producto",
    characteristicsForServiceProduct: "Caracteristicas para un servicio o producto",
    uuidCode: "Código UUID",
    uuidCompany: "UUID de empresa",
    uuidOrName: "UUID/Nombre",
    usersWhoAreSubscribed: "Usuarios que están suscritos y tienen acceso a la empresa",
    viewCompany: "Ver empresa",
    viewMoreUsers: "Ver mas usuarios",
    treasury: "Tesorería",
    treasuryAccount: "Cuenta de tesorería",
    treasuryCashAccount: "Cuenta de Tesorería Efectivo",
    treasuryCardAccount: "Cuenta de Tesorería Tarjeta",
    noCashTreasuryAccounts: "No hay cuentas de tesorería de efectivo disponibles",
    noCardTreasuryAccounts: "No hay cuentas de tesorería de tarjeta disponibles",
    conceptAccount: "Cuenta conceptual",
    treasuryAccounts: "Cuentas de tesorería",
    codeOfBelongingToABankingOrganization: "Código de pertenencia a una entidad bancaria",
    createNewTreasuryAccount: "Crear nueva cuenta de tesorería",
    createTreasuryAccount: "Crear cuenta de tesorería",
    listTreasuryAccounts: "Lista de cuentas de tesorería",
    listBookingJournals: "Lista de asientos contables",
    listAccountingAccounts: "Lista de cuentas contables",
    viewBookingJournal: "Ver asiento contable",
    membership: "Membresía",
    nameOfAccount: "Nombre de la cuenta",
    contactUs: "Contáctenos",
    typeOfTreasuryAccount: "Tipo de cuenta de tesorería",
    updateTreasuryAccountData: "Actualizar datos de cuenta de tesorería",
    viewTreasuryAccountsList: "Ver lista de cuentas de tesorería",
    notification: "Notificación",
    notifications: "Notificaciones",
    accept: "Aceptar",
    accessToCompany: "Acceso a la empresa",
    activities: "Actividades",
    answers: "Respuestas",
    close: "Cerrar",
    companyInvitations: "Invitaciones de empresa",
    hasReceivedANotification: "Ha recibido una notificación",
    hasReceivedAQuote: "Ha recibido una cotización",
    hasReceivedAnInvitation: "Ha recibido una invitación",
    hasReceivedAnOrder: "Ha recibido una pedido",
    newNotification: "Nueva notificación",
    noNotifications: "Sin notificaciones",
    noInvitations: "No hay invitaciones",
    other: "Otro",
    quoteEvaluation: "Evaluación de la cotización",
    quoteNotification: "Notificación de la cotización",
    approve: "Aprobar",
    reject: "Rechazar",
    contact: "Contacto",
    contacts: "Contactos",
    basicBankAccountNumber: "Número de cuenta de tresorería básica",
    bankIdentifierCode: "Código de identificación bancaria / Sociedad para las telecomunicaciones financieras interbancarias mundiales",
    listContacts: "Lista de Contactos",
    contactUUID: "UUID de contacto",
    contactIdentity: "Identidad de contacto",
    contactIsNotAnAppUser: "El contacto no es un usuario de la aplicación",
    contactType: "Tipo de contacto",
    contactUuidAndType: "UUID de contacto y tipo",
    countryContact: "País de contacto",
    createContact: "Crear contacto",
    createNewContact: "Crear nuevo contacto",
    createContactCompanyStructure: "Crear una estructura de contacto de tipo empresa",
    createContactPersonStructure: "Crear una estructura de contacto de tipo persona",
    deleteContact: "Eliminar contacto",
    deleteSelected: "Eliminar seleccionados",
    definingTheIdentityOfContact: "Definición de la identidad del contacto",
    definingTheInformationOfContact: "Definición de la información de contacto",
    definingTheLegalInformationOfContact: "Definición de la información legal de contacto",
    definingTheSettingsToDownloadQuotesAndInvoices: "Definición de la configuración para descargar cotizaciones y facturas",
    dragOrClickOnTheBoxToAddTheCompanyLogo: "Arrastre o haga clic en el cuadro para agregar el logotipo de la empresa",
    editContact: "Editar contacto",
    enterThePostalCodeOfTheCity: "Introduce el código postal de la ciudad",
    exportContacts: "Exportar contactos",
    exportEntryContacts: "Exportar asientos contables",
    extendChanges: "Extender cambios",
    fileDownloadSettings: "Configuración de descarga de archivos",
    financialEntity: "Entidad financiera",
    identityOfContact: "Identidad del contacto",
    ifAddressDoesNotHaveANumber: "Si la dirección no tiene un número, ingrese 'nn' o 'NN'",
    whenNumberIsNotEntered: "Cuando no se ingrese el numero se representa por 'NN'",
    ifNecessaryEnterSomethingReferentialRegardingAddress: "Si es necesario, ingrese algo referencial con respecto a la dirección",
    informationOfContact: "Información de contacto",
    internationalBankAccountNumber: "Número de cuenta de Banco Internacional",
    languageToDownload: "Idioma para descargar cotización, pedido o factura",
    legalInformationOfContact: "Información legal de contacto",
    qrType: "Tipo de QR-factura",
    shapesOrVersionsOfQR: "Formas o versiones de un QR-Factura",
    basicCurrencyCompany: "Divisa basica de la compañia",
    selectCompanyAndSave: "Seleccionar empresa y guardar",
    selectCompaniesToCreateContact: "Seleccione las empresas a la que se va a agregar un nuevo contacto",
    typeOfContact: "Tipo de contacto",
    updateContactData: "Actualizar datos de contacto",
    uuidAndType: "UUID y tipo",
    userUuid: "UUID de usuario",
    viewContact: "Ver contacto",
    addresses: "Direcciones",
    addAddress: "Agregar dirección",
    editAddress: "Editar dirección",
    deleteAddress: "Eliminar dirección",
    addressLabel: "Etiqueta de dirección",
    addressType: "Tipo de dirección",
    deliveryType: "Entrega",
    billingType: "Facturación",
    otherType: "Otro",
    defaultDeliveryAddress: "Dirección de entrega predeterminada",
    setAsDefault: "Establecer como predeterminado",
    mainAddressBadge: "Principal",
    noAddressesYet: "No se han agregado direcciones",
    quote: "Cotización",
    quotes: "Cotizaciones",
    addQuote: "Agregar cotización",
    approveQuote: "Aprobar cotización",
    companyQuoteList: "Lista de cotizaciones de la empresa",
    createQuote: "Crear cotización",
    newQuote: "Nueva cotización",
    dateOfDocument: "Fecha del documento, esto se puede modificar más adelante",
    editQuote: "Editar cotización",
    enterADateOrSelectADefaultPaymentDeadline: "Ingrese una fecha o seleccione una fecha límite de pago predeterminada",
    expired: "Caducado",
    exportQuotes: "Exportar cotizaciones",
    generateQuote: "Generar cotización",
    inTime: "A tiempo",
    listQuotes: "Lista de cotizaciones",
    quoteDate: "Fecha de cotización",
    quoteGroups: "Cotizaciones grupos",
    quoteNumber: "Número de cotización",
    quoteReference: "Referencia de la cotización",
    quoteStatus: "Estado de la cotización",
    quoteValidity: "Validez de cotización",
    rejectQuote: "Rechazar cotización",
    sendQuote: "Enviar cotización",
    updateQuote: "Actualizar cotización",
    viewQuote: "Ver cotización",
    purchases: "Compras",
    sales: "Ventas",
    sale: "Venta",
    principal: "Principal",
    humanResources: "Recursos humanos",
    closingJournal: "Diario de cierre",
    manuallyCreated: "Creado manualmente",
    expenses: "Gastos",
    addExpense: "Agregar gasto",
    createExpense: "Crear gasto",
    editExpense: "Editar gasto",
    expenseDate: "Fecha de gasto",
    expenseGroups: "Grupos de gastos",
    expenseNumber: "Número de gasto",
    expenseValidity: "Validez del gasto",
    invalidateExpense: "Invalidar gasto",
    listExpenses: "Lista de gastos",
    removeExpense: "Eliminar gasto",
    updateExpense: "Actualizar gasto",
    validateExpense: "Validar gasto",
    viewExpense: "Ver gasto",
    addProviderInvoice: "Agregar factura de proveedor",
    createProviderInvoice: "Crear Factura de Proveedor",
    editProviderInvoice: "Editar factura de proveedor",
    invalidateProviderInvoice: "Invalidar factura de proveedor",
    listProviderInvoices: "Lista de facturas de proveedores",
    myTreasuryAccount: "Mi cuenta de tresorería",
    provider: "Proveedor",
    providerBankAccount: "Cuenta bancaria del proveedor",
    providerInvoiceDate: "Fecha de la factura del proveedor",
    providerInvoiceGroups: "Grupos de facturas del proveedor",
    providerInvoiceStatus: "Estado de la factura del proveedor",
    providerInvoiceValidity: "Validez de la factura del proveedor",
    providerInvoices: "Facturas proveedor",
    providerOrderNumber: "Número de pedido del proveedor",
    updateProviderInvoice: "Actualizar factura de proveedor",
    validateProviderInvoice: "Validar factura de proveedor",
    viewProviderInvoice: "Ver factura del proveedor",
    addProviderOrder: "Agregar pedido de proveedor",
    approveProviderOrder: "Aprobar pedido de proveedor",
    cancelProviderOrder: "Cancelar pedido de proveedor",
    createProviderOrder: "Crear pedido de proveedor",
    editProviderOrder: "Editar pedido de proveedor",
    generateProviderInvoice: "Generar factura de proveedor",
    generateProviderOrder: "Generar pedido de proveedor",
    listProviderOrders: "Lista de pedidos de proveedores",
    providerOrderDate: "Fecha de pedido de proveedor",
    providerOrders: "Pedidos de proveedores",
    providerOrderGroups: "Grupos de pedidos de proveedores",
    providerOrderReference: "Referencia del pedido de proveedor",
    providerInvoiceReference: "Referencia de la factura de proveedor",
    expenseReference: "Referencia del gasto",
    providerOrderStatus: "Estado de la orden de proveedor",
    updateProviderOrder: "Actualizar pedido de proveedor",
    viewProviderOrder: "Ver pedido de proveedor",
    providerQuote: "Presupuesto de proveedor",
    providerQuotes: "Presupuestos de proveedores",
    listProviderQuotes: "Lista de presupuestos de proveedores",
    viewProviderQuote: "Ver presupuesto de proveedor",
    sourceQuoteNumber: "Ref. presupuesto origen",
    sourceCompany: "Empresa emisora",
    acceptQuote: "Aceptar presupuesto",
    declineQuote: "Rechazar presupuesto",
    internalNotes: "Notas internas",
    saveNotes: "Guardar notas",
    providerQuoteAccepted: "Presupuesto aceptado, pedido de proveedor creado",
    providerQuoteDeclined: "Presupuesto rechazado",
    confirmAcceptQuote: "Aceptar este presupuesto? Se creara un pedido de proveedor automaticamente.",
    confirmDeclineQuote: "Rechazar este presupuesto?",
    declineReasonLabel: "Motivo del rechazo",
    declineReasonPlaceholder: "Por favor, explique por qué rechaza este presupuesto...",
    declineInvoiceReasonPlaceholder: "Por favor, explique por qué rechaza esta factura...",
    declineReasonRequired: "Se requiere un motivo para rechazar.",
    recipientDecision: "Decisión del destinatario",
    decisionAccepted: "Aceptado por el destinatario",
    decisionDeclined: "Rechazado por el destinatario",
    decisionDate: "Fecha de la decisión",
    declineReason: "Motivo del rechazo",
    acceptanceStatus: "Estado de aceptación",
    acceptancePending: "Pendiente de aceptación",
    acceptanceNotRequired: "No requerido",
    acceptInvoice: "Aceptar factura",
    declineInvoice: "Rechazar factura",
    providerInvoiceAccepted: "Factura aceptada",
    providerInvoiceDeclined: "Factura rechazada",
    confirmAcceptInvoice: "¿Aceptar esta factura?",
    confirmDeclineInvoice: "¿Rechazar esta factura?",
    seeProviderOrder: "Ver pedido de proveedor",
    addVouchers: "Añadir comprobante(s)",
    download: "Descargar",
    file: "Archivo",
    lastModified: "Última modificación",
    size: "Tamaño",
    vouchers: "Comprobantes",
    addFiles: "Añadir archivos",
    attachFiles: "Adjuntar archivos",
    removeAll: "Eliminar todo",
    uploadFiles: "Subir archivos",
    orders: "Pedidos",
    order: "Pedido",
    orderEvaluation: "Evaluación del pedido",
    orderGroups: "Grupos de pedidos",
    orderNotification: "Notificación de pedido",
    orderReference: "Referencia del pedido",
    orderStatus: "Estado del pedido",
    addOrder: "Agregar pedido",
    approveOrder: "Aprobar pedido",
    rejectOrder: "Rechazar pedido",
    cancelOrder: "Cancelar pedido",
    companyListOfOrders: "Lista de pedidos de la empresa",
    companyListOfInvoices: "Lista de facturas de la empresa",
    companyListOfQuotes: "Lista de cotizaciones de la empresa",
    companyListOfProviderInvoices: "Lista de facturas de proveedor",
    companyListOfProviderOrders: "Lista de pedidos de proveedor",
    companyListOfProviderQuotes: "Lista de cotizaciones de proveedor",
    companyListOfExpenses: "Lista de gastos",
    companyListOfExpenseReports: "Lista de notas de gastos",
    createOrder: "Crear pedido",
    delivery: "Entrega",
    deliveyAddress: "Dirección de entrega",
    deliveryNote: "Nota de entrega",
    deliveryNotes: "Notas de entrega",
    createDeliveryNote: "Crear nota de entrega",
    noDeliveryNotesYet: "Aún no hay notas de entrega",
    delivered: "Entregado",
    notDelivered: "No entregado",
    deliveryDate: "Fecha de entrega",
    deliverAll: "Entregar todo",
    quantityToDeliver: "Cant. a entregar",
    quantityOrdered: "Cant. pedida",
    quantityDelivered: "Cant. entregada",
    quantityRemaining: "Cant. restante",
    alreadyFullyDelivered: "Ya completamente entregado",
    quantityReceived: "Cant. recibida",
    quantityToEnter: "Cant. a ingresar",
    allItemsReceived: "Todos los artículos han sido recibidos",
    selectAtLeastOneQuantity: "Por favor seleccione al menos una cantidad a ingresar",
    sendByEmail: "Enviar por correo electrónico",
    sendToCustomer: "Enviar al cliente",
    personalizedMessage: "Mensaje personalizado",
    deliveryAddressSelection: "Selección de dirección de entrega",
    mainAddress: "Dirección principal",
    manageAddresses: "Gestionar direcciones",
    storageCenterSelection: "Selección de centro de almacenamiento",
    autoStockOut: "Salida automática de stock",
    quantityInStock: "Cantidad en stock",
    stockAvailability: "Disponibilidad de stock",
    stockWarnings: "Alertas de stock",
    deliveryProgress: "Progreso de entrega",
    deliveryComplete: "Entrega completa",
    deliveryPartial: "Entrega parcial",
    notDeliveredYet: "Aún no entregado",
    deliveryAddressLabel: "Dirección de entrega",
    sentAt: "Enviado el",
    sentMethod: "Método de envío",
    backToOrder: "Volver al pedido",
    linesDelivered: "Líneas entregadas",
    createInvoiceFromSelection: "Crear factura desde la selección",
    ordersWillBeInvoicedTogether: "pedido(s) serán facturados juntos",
    ordersSelected: "pedido(s) seleccionado(s)",
    editOrder: "Editar pedido",
    exportOrder: "Exportar pedido",
    exportOrders: "Exportar pedidos",
    generateInvoice: "Generar factura",
    generateOrder: "Generar pedido",
    listOrders: "Lista de pedidos",
    orderDate: "Fecha del pedido",
    orderFile: "Archivo de pedido",
    orderNumber: "Número de pedido",
    selectExportType: "Seleccionar tipo de exportación",
    sendOrder: "Enviar pedido",
    thisOptionIsUniqueAndNewInvoice: "Esta opción es única y no se puede crear una nueva factura a partir de este pedido",
    updateOrder: "Actualizar pedido",
    viewOrder: "Ver pedido",
    invoice: "Factura",
    invoices: "Facturas",
    addInvoice: "Agregar factura",
    amountDebt: "Monto de deuda",
    amountPaid: "Monto pagado",
    companyInvoiceList: "Lista de facturas de la empresa",
    createInvoice: "Crear factura",
    editInvoice: "Editar factura",
    exportInvoices: "Exportar facturas",
    exportProviderInvoices: "Exportar facturas de proveedor",
    exportProviderOrders: "Exportar pedidos de proveedor",
    exportProviderQuotes: "Exportar cotizaciones de proveedor",
    exportExpenses: "Exportar gastos",
    exportExpenseReports: "Exportar notas de gastos",
    debt: "Deuda",
    fullyPaid: "Totalmente pagado",
    invalidInvoices: "Facturas no válidas",
    invalidateInvoice: "Invalidar factura",
    invalidateProviderOrder: "Invalidar orden de proveedor",
    validateProviderOrder: "Validar orden de proveedor",
    invoiceGroups: "Grupos de facturas",
    invoiceDate: "Fecha de factura",
    invoiceNumber: "Número de factura",
    invoiceStatus: "Estado de factura",
    invoiceValidity: "Validez de factura",
    listInvoices: "Lista de facturas",
    notPayed: "No pagado",
    partiallyPaid: "Parcialmente pagado",
    payed: "Pagado",
    thisInvoiceHasNoPayments: "Esta factura no tiene pagos",
    updateInvoice: "Actualizar factura",
    validated: "Validado",
    validateInvoice: "Validar factura",
    viewInvoice: "Ver factura",
    youWillBeAbleToUndoThisAction: "Podrá deshacer esta acción",
    payment: "Pago",
    payments: "Pagos",
    amountToPay: "Cantidad a pagar",
    createNewPayment: "Crear nuevo pago",
    deleteSomePayment: "Eliminar algún pago",
    doNotDeletePayments: "No eliminar ningún pago",
    makePayment: "Realizar pago",
    method: "Método",
    paymentDate: "Fecha de pago",
    paymentMethod: "Método de pago",
    save: "Guardar",
    sourceOfIncome: "Fuente de ingresos",
    accountingAccountProductService: "Cuenta contable del producto o servicio",
    sourceTheAmount: "Fuente a donde se ingresa o retira el monto de dinero de la transaccion",
    sourceTheAmountEntered: "Fuente a donde se ingresa el monto de dinero de la transaccion",
    sourceTheAmountWithdrawn: "Fuente de donde se retira el monto de dinero de la transaccion",
    cash: "Efectivo",
    card: "Tarjeta",
    payPal: "PayPal",
    transfer: "Transferencia",
    mobile: "Móvil",
    thisOptionIncludeTaxPrice: "Esta opción incluye el impuesto en el precio indicado",
    thisOptionNotIncludeTaxPrice: "Esta opción no incluye el impuesto en el precio indicado",
    addOrRemoveContactCompanies: "Agregar o eliminar contactos de empresas",
    notifyMe: "Notificarme",
    background: "Fondo",
    inventory: "Inventario",
    viewProduct: "Ver producto",
    storageCenter: "Centro de almacenamiento",
    listStorageCenter: "Lista de centros de almacenamiento",
    viewStorageCenter: "Vista del centro de almacenamiento",
    afterSalesService: "Servicio postventa",
    bookingJournals: "Diarios contables",
    appLanguage: "Idioma de la aplicación",
    theUuidCanBeUsedToCreateNnewContact: "El UUID se puede utilizar para crear un nuevo contacto",
    settingInformation: "Información de configuración",
    addOrRemoveCompanies: "Agregar/Eliminar empresas",
    notGrouped: "Sin agrupar",
    notFiltered: "Sin filtrar",
    orderValidity: "Validez del pedido",
    expiration: "Vencimiento",
    quoteExpiration: "Vencimiento de cotización",
    orderExpiration: "Vencimiento de orden",
    invoiceExpiration: "Vencimiento de factura",
    discountTotal: "Descuento total",
    addService: "Agregar servicio",
    addProduct: "Agregar producto",
    noRecords: "Sin registros",
    quantityMinimumForRebate: "Cantidad mínima para rebaja",
    nonExistentRebateNegativePrice: "Rebaja inexistente por precio negativo",
    thisOptionRebateIsFixedAmount: "Esta opción indica que la rebaja es un monto fijo",
    thisOptionRebateIsPercentage: "Esta opción indica que la rebaja es un porcentaje",
    thisOptionRebateIsNone: "Esta opción indica que la rebaja es nula",
    totalAfterRebates: "Total después de rebajas",
    calculator: "Calculadora",
    enterRebate: "Ingrese la rebaja",
    reference: "Referencia",
    newOrder: "Nuevo pedido",
    invoiceReference: "Referencia de la factura",
    newInvoice: "Nueva factura",
    providerOrderValidity: "Validez del pedido del proveedor",
    expenseStatus: "Estado de gastos",
    newProviderOrder: "Nuevo pedido de proveedor",
    newProviderInvoice: "Nueva factura de proveedor",
    newExpense: "Nuevo gasto",
    viewVoucher: "Ver comprobante",
    informationAdditional: "Información adicional",
    no: "No",
    bank: "Banco",
    fullNameBankAccountHolder: "Nombre completo del titular de la cuenta bancaria",
    bankAccountHolder: "Titular de la cuenta bancaria",
    isNecessaryToHaveReferenceToActivateOption: "Es necesario contar con una referencia para activar esta opción",
    isNecessaryToHaveAtLeastTwoTreasuryAccountsToActivateOption:
      "Es necesario contar con al menos dos cuentas de tesoreria para activar esta opción",
    none: "Ninguno",
    undefined: "Indefinido",
    colorCombinationForDesignOfDocumentToDownload: "Combinación de colores para el diseño del documento a descargar",
    all: "Todo",
    lettersTitlesSubtitles: "Letras títulos subtítulos",
    firstBar: "Primera barra",
    secondBar: "Segunda barra",
    barLetters: "Letras de la barra",
    qrIbanAndQrReference: "QR-IBAN y QR-Referencia",
    ibanAndStructuredCreditorReference: "IBAN y Referencia de Acreedor Estructurado (SCOR)",
    ibanWithoutReference: "IBAN Sin Referencia",
    cashAccount: "Cuenta efectiva",
    postalAccount: "Cuenta postal",
    bankAccount: "Cuenta bancaria",
    currentAccount: "Cuenta corriente de socios",
    listProducts: "Lista de productos",
    category: "Categoría",
    categories: "Categorias",
    listCategories: "Lista de categorias",
    tags: "Etiquetas",
    variants: "Variantes",
    photography: "Fotografía",
    reminder: "Recordatorio",
    reminders: "Recordatorios",
    paymentStatus: "Estado de pago",
    year: "Año",
    createReminder: "Crear recordatorio",
    updateReminder: "Actualizar recordatorio",
    makeCopy: "Crear copia",
    reminderTotal: "Total recordatorio",
    inDispute: "En disputa",
    addCategory: "Agregar categoría",
    addStorageCenter: "Agregar centro de almacenamiento",
    addBookingJournal: "Agregar diario contable",
    qtyAssets: "QTY activos",
    qtyServices: "QTY servicios",
    qtyProducts: "QTY productos",
    viewCategory: "Ver categoría",
    editCategory: "Editar categoria",
    deleteCategory: "Eliminar categoria",
    names: "Nombres",
    listCategoryItems: "Lista de elementos de la categoria",
    editListing: "Editar listado",
    updateCategoryItemList: "Actualizar lista de elementos de la categoría",
    updateCategory: "Actualizar categoría",
    nameInOtherLanguages: "Nombre en otros idiomas",
    enterInLanguageWant: "Ingresa el idioma que desees",
    enterNameOfRequestedLanguages: "Ingresa el nombre de los idiomas solicitados",
    enterDesiredValuePressEnterAdd: "Ingrese el valor deseado y pulse enter para agregarlo",
    enterOrModifyInLanguage: "Ingresa o modifica en el idioma que desees",
    general: "General",
    categoryName: "Nombre de la categoría",
    categoryType: "Tipo de categoría",
    createCategory: "Crear categoría",
    editProduct: "Editar producto",
    deleteProduct: "Eliminar producto",
    productReferencePictures: "Imágenes de referencia del producto",
    code: "Código",
    sku: "SKU",
    codebar: "Codigo de barras",
    color: "Color",
    unit: "Unidad",
    price: "Precio",
    priceSale: "Precio de venta",
    pricePurchase: "Precio de compra",
    fixed: "Fijado",
    productName: "Nombre del producto",
    productDetails: "Detalles del producto",
    advanced: "Avanzado",
    addVariant: "Añadir variante",
    uniqueProductCodeAssignedByCompany: "Código de producto único asignado por la empresa",
    additionalCommentDescriptionProductVariant: "Comentario o descripcion adicional a la variante del producto",
    selectDiscountTypeAppliedToProduct: "Seleccione un tipo de descuento que se aplicará a este producto",
    discountType: "Tipo de descuento",
    selectDiscountTypeThatWillAppliedProduct: "Seleccione un tipo de descuento que se aplicará a este producto",
    noDiscount: "Sin descuento",
    setDiscountPercentage: "Establecer porcentaje de descuento",
    fixedDiscountedAmount: "Monto fijo del descuento",
    quantityMinimumDiscount: "Cantidad mínima para descuento",
    createProduct: "Crear producto",
    dropFilesHereOrClickUpload: "Suelte los archivos aquí o haga clic para cargarlos",
    dropFileHereOrClickUpload: "Suelte el archivo aquí o haga clic para cargarlo",
    uploadUpToFiles: "Cargue hasta 10 archivos",
    success: "Éxito",
    addNewProductVariant: "Agregar nueva variante de producto",
    editVariant: "Editar variante",
    editProductVariant: "Editar variante del producto",
    updateProduct: "Actualizar producto",
    saveVariant: "Guardar variante",
    listServices: "Lista de servicios",
    viewService: "Ver servicio",
    editService: "Editar servicio",
    deleteService: "Eliminar servicio",
    serviceReferencePictures: "Imágenes de referencia de servicio",
    serviceName: "Nombre del servicio",
    serviceDetails: "Detalles del servicio",
    createService: "Crear servicio",
    updateService: "Actualizar servicio",
    uniqueServiceCodeAssignedByCompany: "Código de servicio único asignado por la empresa",
    selectDiscountTypeAppliedToService: "Seleccione un tipo de descuento que se aplicará a este servicio",
    expenseAccount: "Cuenta de gastos",
    vatAccount: "Cuenta de IVA",
    accountProduct: "Cuenta de producto",
    accountingAccount: "Cuenta contable",
    accountingAccounts: "Cuentas contables",
    accountingAccountPurchases: "Cuenta contable para compras",
    accountingAccountSales: "Cuenta contable para ventas",
    addAccountingAccount: "Agregar cuenta contable",
    rangeAllowedCodes: "Rango de codigos permitidos",
    effective: "Liquidación efectiva",
    tdfn: "Tasa de deuda fiscal neta (TDFN)",
    taf: "Tasa forfaitaria (TaF)",
    vatAccountingType: "Tipo de liquidación del IVA",
    theVatRegimeCanOnlyChangedOnceAYear:
      "El regimen de la IVA solo se puede cambiar una vez al año, justo antes de empezar un nuevo año contable",
    debit: "Débito",
    credit: "Crédito",
    customerReceivable: "Cliente por cobrar",
    providerReceivable: "Proveedor por cobrar",
    vatDue: "IVA adeudado",
    vatRecoverable: "IVA recuperable",
    declarationMethod: "Método de declaración",
    onInvoicing: "Según la facturación (al facturar)",
    onCashing: "Según los cobros (al cobrar)",
    valid: "Válido",
    invalid: "Inválido",
    colorIsInvalid: "Color inválido",
    theValueIsNotAValid: "El valor no es válido",
    theValueIsNotAValidUUIDOrNameUser: "El valor no es un UUID o nombre de usuario válido",
    theValueIsAtLeast8Digits: "El valor tiene al menos 8 dígitos",
    theValueDoesNotMatch: "El valor no coincide",
    theValueAlreadyExists: "El valor ya existe",
    limitFilesMaximum: "Límite de 10 archivos máximo",
    required: "Requerido",
    theValueIsRequired: "El valor es obligatorio",
    allValuesRequired: "Todos los valores son obligatorios",
    colorIsRequired: "El color es obligatorio",
    requirementsIsRequired: "Se requieren bloques",
    paymentsIsRequired: "Se requieren pagos",
    contentsToRequirementIsRequired: "Se requiere el contenido del bloque",
    transaction: "Transacción",
    createNewPaymentForInvoice: "Crear nuevo pago para la factura",
    createNewPaymentForProviderInvoice: "Crear nuevo pago para la factura del proveedor",
    addTransaction: "Agregar transacción",
    accountingEntry: "Asiento contable",
    amountAvailable: "Monto disponible",
    selectExistingTransaction: "Seleccionar transacción existente",
    totalAmountDebt: "Monto total de la deuda",
    presetCurrency: "Moneda preestablecida",
    deposit: "Depósito",
    deposition: "Depósito",
    depositAmount: "Monto de deposito",
    pastTransactions: "Transacciones anteriores",
    noPastTransactions: "Sin transacciones anteriores",
    selectTransaction: "Seleccionar una transacción",
    providerInvoice: "Factura del proveedor",
    expense: "Gasto",
    enterNewTransaction: "Introducir una nueva transacción",
    useExistingTransaction: "Utilizar una transacción existente",
    transactionToRecordPayment: "Transacción para poder registrar el pago",
    amountMoneyEnteredInTransaction: "Monto del dinero ingresado en la transacción",
    amountMoneyWithdrawnInTransaction: "Monto de dinero retirado en la transacción",
    identifiedTransactions: "Transacciones identificadas",
    unidentifiedTransactions: "Transacciones no identificadas",
    totalDepositAmount: "Monto total del depósito",
    makeCorrespondingPayment: "Realizar el pago correspondiente",
    balance: "Saldo",
    accountingEntries: "Asientos contables",
    contactBalance: "Saldo del contacto",
    accountStatement: "Estado de cuenta",
    accountStatements: "Estado de cuentas",
    invoiceIssuance: "Emisión de la factura",
    saleIssuance: "Emisión de venta",
    providerInvoiceIssuance: "Emisión de la factura del proveedor",
    expenseIssuance: "Emisión del gasto",
    allocationInvoiceReminder: "Asignación por recordatorio de factura",
    transactionToPostFinance: "Transacción a la cuenta PostFinance",
    transactionFormPostFinance: "Transacción desde la cuenta PostFinance",
    balancePrevious: "Saldo anterior",
    includeOpeningBalance: "Incluir saldo de apertura",
    balanceFavorContact: "Saldo a tu favor",
    balanceFavorCompany: "Saldo a nuestro favor",
    addCredit: "Añadir crédito",
    addDebit: "Añadir débito",
    createClientCredit: "Nuevo asiento al crédito",
    createClientDebit: "Nuevo asiento al débito",
    unidentifiedTransactionToRegisterInContact: "Transacción no identificada para registrarlo en el contacto",
    draft: "Borrador",
    revertToDraft: "Volver a borrador",
    beforeCreatingProviderInvoice: "Antes de crear una factura de proveedor",
    beforeCreatingProviderOrder: "Antes de crear una orden de proveedor",
    beforeCreatingExpense: "Antes de crear un gasto",
    viewPdf: "Ver PDF",
    viewOriginalPdf: "Ver PDF original",
    documentPdf: "PDF del documento",
    viewReferencePdf: "Visualizar PDF de referencia",
    referencePdf: "PDF de referencia",
    invalidFileType: "Archivo en diferente formato",
    fileInDifferentFormatImg: "Archivo en diferente formato. Tipos de archivo permitidos: jpeg, jpg o png",
    fileSizeNotAllowed: "Archivo demasiado grande. Tamaño máximo de archivo: 1 MB",
    fileInDifferentFormatPdf: "Archivo en diferente formato. Formato de archivo: pdf",
    fileIsTooBig: "El archivo es demasiado grande. Tamaño máximo de archivo: 10 MB",
    addDocument: "Agregar documento",
    validate: "Validar",
    invalidate: "Invalidar",
    listing: "Listado",
    creation: "Creación",
    accounting: "Contabilidad",
    generalLedger: "Libro mayor",
    bookingJournal: "Diario contable",
    label: "Etiqueta",
    multipleWriting: "Escritura múltiple",
    simplifiedMultipleWriting: "Escritura múltiple simplificada",
    availableAmount: "Cantidad disponible",
    level: "Nivel",
    coefficient: "Coeficiente",
    leave: "Hoja",
    title: "Título",
    writingSimple: "Escritura simple",
    writingMultiple: "Escritura múltiple",
    writingSimplifiedMultiple: "Escritura múltiple simplificada",
    taxIncluded: "Con IVA",
    taxExcluded: "Without IVA",
    taxFee: "Tasa de impuesto (IVA)",
    vatOptions: "Opciones de IVA",
    interest: "Interés",
    penalty: "Multa",
    refund: "Reembolso",
    creditNote: "Nota de crédito",
    customerInterest: "Interés del cliente",
    customerPenalty: "Sanción del cliente",
    customerRefund: "Reembolso del cliente emitido",
    providerPayment: "Pago del proveedor emitido",
    providerCreditNote: "Nota de crédito del proveedor emitida",
    providerInterest: "Interés del proveedor",
    providerPenalty: "Sanción del proveedor",
    providerRefund: "Reembolso del proveedor recibido",
    customerPayment: "Pago recibido de un cliente",
    customerCreditNote: "Nota de crédito del cliente emitido",
    transactionType: "Tipo de transacción",
    resend: "Volver a enviar",
    information: "Información",
    generalInformation: "Información general",
    vatCalculationPeriod: "Periodo de cálculo del IVA",
    dependsWhetherCompanySubjectTax: "Depende de si la empresa esta sujeta a impuestos",
    dependsCompanySpecialVatRegime: "Depende del régimen especial de IVA de la empresa",
    dependsCompanyVatCalculationPeriod: "Depende del periodo de calculo de IVA de la empresa",
    upcomingVatStatement: "Próxima declaración de IVA",
    deadline: "Fecha limite",
    quarter: "Trimestre",
    semester: "Semestre",
    chartAccounts: "Plan de cuentas",
    vatStatement: "Declaración de IVA",
    listVatStatements: "Lista de declaraciones de IVA",
    manual: "Manual",
    vatSettingsMap: "Mapa de configuración del IVA",
    listPeriodsStatement: "Listado de periodos para la declaración del IVA",
    vatAmount: "IVA",
    vatAmountDue: "Importe IVA adeudado",
    regime: "Régimen",
    calculation: "Cálculo",
    tickets: "Tickets",
    pendingVatTickets: "Tickets IVA pendientes",
    orphansOnly: "Solo huérfanos",
    formLine: "Línea form.",
    vatShort: "IVA",
    side: "Lado",
    accrual: "Acumulación",
    open: "Abierto",
    filed: "Archivado",
    closed: "Cerrado",
    listPeriodStatement: "Lista del periodo de declaración",
    exportStatementPeriod: "Exportación del periodo de declaración",
    editAccountingSettings: "Editar configuración de contabilidad",
    brand: "Marca",
    features: "Características",
    createStorageCenter: "Crear centro de almacenamiento",
    updateStorageCenter: "Actualizar centro de almacenamiento",
    editStorageCenter: "Editar centro de almacenamiento",
    addInventory: "Añadir al inventario",
    storagePurchase: "Almacenamiento para la compra",
    operations: "Operaciones",
    storageOperations: "Operaciones de almacenamiento",
    listOperationsStorageCenter: "Lista de operaciones de un centro de almacenamiento",
    sourceLocation: "Ubicación de origen",
    destinationLocation: "Ubicación de destino",
    source: "Fuente",
    invalidated: "Invalidado",
    in: "Dentro",
    out: "Fuera",
    adjustment: "Ajuste",
    stockEntry: "Entrada de stock",
    stockExit: "Salida de stock",
    stockTransfer: "Transferencia de stock",
    sourceStorageCenter: "Centro de salida",
    destinationStorageCenter: "Centro de entrada",
    availableStock: "Stock disponible",
    quantityToTransfer: "Cantidad a transferir",
    addLine: "Añadir una línea",
    selectProduct: "Seleccionar un producto",
    removeLine: "Eliminar",
    providerOrder: "Orden del proveedor",
    updatePos: "Actualizar POS",
    pos: "POS",
    listPOS: "Listar POS",
    createPOS: "Crear POS",
    createNewPOS: "Crear nuevo POS",
    viewPOS: "Ver POS",
    createSale: "Crear venta",
    pointOfSale: "Punto de venta",
    selectProducts: "Seleccionar productos",
    selectedItems: "Items seleccionados",
    noItemsSelected: "No hay items seleccionados",
    step1: "Paso 1",
    step2: "Paso 2",
    paymentMethods: "Métodos de pago",
    received: "Recibido",
    totalPaid: "Total pagado",
    totalCash: "Total efectivo",
    totalCard: "Total tarjeta",
    paymentCalculation: "Cálculo de pago",
    completeSale: "Completar venta",
    listOfSales: "Lista de ventas",
    noTransactionsToday: "No hay transacciones hoy",
    totalTransactions: "Total de transacciones",
    active: "Activo",
    inactive: "Inactivo",
    startCreatingNewPOSForYourCompany: "Empieza creando nuevos POS para tu empresa",
    add: "Agregar",
    change: "Vuelto",
    cashier: "Cajero",
    saleNumber: "Número de venta",
    viewSale: "Ver venta",
    return: "Devolver",
    createNewSale: "Crear nueva venta",
    defaultCustomerSale: "Cliente por defecto de una venta",
    heWantsAccessApplicationLink: "Esta deseando ingresar a la aplicacion mediante un link",
    security: "Seguridad",
    signOutAllDevices: "Cerrar sesión en todos los dispositivos",
    editDeadlinePaymentParameter: "Editar parámetro de plazo de pago",
    editFeatureParameter: "Editar parámetro de característica",
    editMeasureUnitParameter: "Editar parámetro de unidad de medida",
    addMeasureUnitParameter: "Agregar parámetro de unidad de medida",
    areYouSureYouWantToDeleteThisRecord: "¿Estás seguro de que deseas eliminar este registro?",
    youWontBeAbleToRevertThis: "No podrás revertir esta acción",
    yesDeleteIt: "Sí, eliminarlo",
    confirmPurchase: "Confirmar compra",
    confirmPurchaseDesignMessage: "¿Deseas confirmar la compra de este diseño?",
    yesPurchase: "Sí, comprar",
    companyColorSettings: "Configuración de colores de la empresa",
    saveColors: "Guardar colores",
    companyDesignSettings: "Configuración de diseño de la empresa",
    currentDesign: "Diseño actual",
    setAsCurrent: "Establecer como actual",
    subjectToVat: "Sujeto a IVA",
    companySwitchingNotAvailableInView:
      "El cambio de compañía no está disponible en esta vista; solo puede realizarse desde las vistas generales de la compañía",

    // Start sentence
    selectOneOption: "Seleccione una de las opciones,",
    iAgree: "Acepto &",
    youWantToChangeOrderStatusTo: "¿Desea cambiar el estado del pedido a",
    createdAt: "Creado en",
    updatedAt: "Actualizado en",
    validUntil: "Válido hasta",
    clickOn: "Hacer clic en",
    thisContactWillOnlyBeRegisteredInCompany: "Este contacto solo se registrara en la empresa",
    securedPaymentBy: "Pago asegurado por",
    anInvitationWillBeSent: "Se enviará una invitación para acceder a la empresa",
    ifYouNeedMoreInfo: "Si necesita más información, consulte en",
    theInvitationToAccess: "La invitación para acceder a la empresa por parte del usuario",
    theQuoteThatYouSent: "La cotización que envió la empresa",
    youHaveAlreadyEvaluatedOrder: "Ya has evaluado la orden de la empresa",
    youHaveAlreadyEvaluatedQuote: "Ya has evaluado la cotización de la empresa",
    youHaveAlreadyRespondedTo: "Ya has respondido a",
    youHaveReceivedAQuote: "Ha recibido una cotización de la empresa",
    ifYouDoNotWishToExtendContactModificationsToOtherCompanies:
      "Si no desea extender las modificaciones de contacto a otras empresas, no marque ninguna y seleccione",
    youWantToChangeQuoteStatusTo: "Desea cambiar el estado de la cotización a",
    youWantToChangeProviderOrderStatusTo: "Desea cambiar el estado del pedido de proveedor a",
    theOrderThatYouSent: "El pedido que envió la empresa",
    youHaveReceivedAnOrder: "Ha recibido un pedido de la empresa",
    theCurrentCompanyIs: "La empresa actual es",
    toCreateA: "Para crear una",
    createdBy: "Creado por",
    groupBy: "Agrupar por",
    checkOrUncheck: "Marque o desmarque los",
    ifYouWishChangeVatRegimePleaseContact: "Si desea cambiar el regimen del IVA tiene que contactar a",
    ifYouInvalidateInvoice: "Si invalida la factura",
    ifYouInvalidateProviderOrder: "Si invalida la orden del proveedor",
    ifYouInvalidateProvaiderInvoice: "Si invalida la factura del proveedor",
    ifYouInvalidateExpense: "Si invalida el gasto",
    the: "La",
    planYourBusinessApplications: "Planifique sus aplicaciones comerciales eligiendo uno de",
    yourAccountIsNotVerified:
      "Su cuenta no está verificada. Valide su cuenta a través de su dirección de correo electrónico, haciendo clic en el boton",
    chargeFor: "Cargo por",
    serverErrorOccurred: "Se produjo un error en el servidor",
    noResponseServer: "No se recibió respuesta del servidor",
    serviceTemporarilyUnavailable: "El servicio no está disponible temporalmente. Por favor, inténtelo de nuevo.",
    records: "Registros",
    invitations: "Invitaciones",
    consignment: "Consignación",
    consignmentReturn: "Devolución de consignación",
    consignments: "Consignaciones",
    listConsignments: "Lista de consignaciones",
    commissionType: "Tipo de comisión",
    commissionRate: "Tasa de comisión",
    newConsignment: "Nuevo acuerdo",
    receiveProducts: "Recibir productos",
    returnProducts: "Devolver no vendidos",
    generateReport: "Generar informe",
    quantitySold: "Cant. vendida",
    quantityReturned: "Cant. devuelta",
    quantityAvailable: "Cant. disponible",
    quantityToReturn: "Cant. a devolver",
    totalSoldValue: "Valor total vendido",
    commissionAmount: "Monto comisión",
    amountDueToProvider: "Monto debido al proveedor",
    closeAgreement: "Cerrar acuerdo",
    consignmentAgreement: "Acuerdo de consignación",
    fixedPrice: "Precio fijo",
    documents: "Documentos",
    document: "Documento",
    listDocuments: "Lista de documentos",
    uploadDocument: "Subir documento",
    assignDocument: "Asignar documento",
    archiveDocument: "Archivar documento",
    unarchiveDocument: "Desarchivar documento",
    ignoreDocument: "Ignorar documento",
    unignoreDocument: "Restaurar documento",
    inbox: "Bandeja de entrada",
    archives: "Archivo",
    youWantToIgnoreThisDocument: "¿Quieres ignorar este documento?",
    youWantToUnignoreThisDocument: "¿Quieres restaurar este documento?",
    youWantToArchiveThisDocument: "¿Quieres archivar este documento?",
    youWantToUnarchiveThisDocument: "¿Quieres desarchivar este documento?",
    successfullyIgnored: "Documento ignorado con éxito",
    successfullyUnignored: "Documento restaurado con éxito",
    successfullyArchived: "Documento archivado con éxito",
    successfullyUnarchived: "Documento desarchivado con éxito",
    cannotIgnoreDocument: "No se puede ignorar el documento",
    cannotIgnoreDocumentWithAssignments: "Este documento tiene asignaciones activas. Elimínelas antes de ignorarlo.",
    deleteDocument: "Eliminar documento",
    fileName: "Nombre del archivo",
    assignedTo: "Asignado a",
    assigned: "Asignado",
    preview: "Vista previa",
    downloadFile: "Descargar archivo",
    upload: "Subir",
    assign: "Asignar",
    documentType: "Tipo de documento",
    documentReference: "Referencia del documento",
    enterDocumentReference: "Ingrese la referencia del documento",
    partiallyProcessed: "Parcialmente procesado",
    processed: "Procesado",
    originalFile: "Archivo original",
    documentDate: "Fecha del documento",
    uploadedOn: "Subido el",
    documentDetails: "Detalles del documento",
    documentName: "Nombre del documento",
    previewNotAvailable: "Vista previa no disponible",
    documentUpdated: "Documento actualizado",
    createFromDocument: "Crear desde documento",
    attachExistingDocument: "Adjuntar documento existente",
    selectDocumentToAttach: "Seleccionar un documento para adjuntar",
    documentAttached: "Documento adjuntado exitosamente",
    noDocumentsAvailable: "No hay documentos disponibles",
    attach: "Adjuntar",
    uploadNewPdf: "Subir nuevo PDF",
    removeDocument: "Eliminar",
    confirmRemoveVoucher: "¿Eliminar este documento?",
    brands: "Marcas",
    youWantToDeleteThisBrand: "¿Deseas eliminar esta marca?",
    listBrands: "Lista de marcas",
    createBrand: "Crear marca",
    searchBrand: "Buscar marca",
    clear: "Limpiar",
    sortBy: "Ordenar por",
    show: "Mostrar",
    perPage: "por página",
    showing: "Mostrando",
    of: "de",
    nameRequired: "Nombre requerido",
    nameIsRequired: "El nombre es obligatorio",
    updateBrand: "Actualizar marca",
    enterBrandName: "Ingrese el nombre de la marca",
    logoUrlHint: "Ingrese la URL del logotipo",
    processing: "Procesando",
    editBrand: "Editar marca",
    logoUrl: "URL del logotipo",
    addBrand: "Agregar marca",
    selectBrand: "Seleccionar marca",
    noBrandsAvailable: "No hay marcas disponibles",

    // End sentence
    companyPleaseEvaluateQuote: ", evalúe la cotización.",
    theAssociatedAccountingEntriesWillBeDeletedInvoice:
      ", las escrituras contables asociadas serán eliminadas. Esto implica que no podrá realizar pagos ni generar tarifas de recordatorios relacionados con dicha factura.",
    theAssociatedAccountingEntriesWillBeDeletedProviderInvoice:
      ", las escrituras contables asociadas serán eliminadas. Esto implica que no podrá realizar pagos ni generar tarifas de recordatorios relacionados con dicha factura de proveedor.",
    theAssociatedAccountingEntriesWillBeDeletedExpense:
      ", las escrituras contables asociadas serán eliminadas. Esto implica que no podrá realizar pagos ni generar tarifas de recordatorios relacionados con dicho gasto.",
    theAssociatedProductsWillBeRemoved:
      ", los productos asociados serán eliminados. Esto implica que no se registrarán en el inventario de los centros de almacenamiento relacionados con dicha orden del proveedor.",
    ifYouWishToSaveTheChangesMade: "si desea guardar los cambios realizados.",
    youWantToRun: "que desea ejecutar.",
    toContinue: "para continuar.",
    waitAMomentToVerifyYourAccess: "espera un momento para verificar tu acceso.",
    hasSentARequestForAccessToTheFollowingCompany: "ha enviado una solicitud de acceso a la siguiente empresa, por favor responda.",
    ifYouWantToSaveTheNewQuote: "si desea guardar la nueva cotización.",
    ifYouWantToSaveTheNewQuoteWithTheChangesMade: "si desea guardar la nueva cotización con los cambios realizados.",
    ifYouWantToSaveTheNewInvoiceWithTheChangesMade: "si desea guardar la nueva factura con los cambios realizados.",
    ifYouWantToSaveTheNewExpense: "si desea guardar el nuevo gasto.",
    ifYouWantToSaveTheNewProviderInvoice: "si desea guardar la nueva factura del proveedor.",
    ifYouWantToSaveTheNewProviderOrder: "si desea guardar el nuevo pedido de proveedor.",
    ifYouWantToSaveTheNewProviderOrderWithTheChangesMade: "si desea guardar el nuevo pedido de proveedor con los cambios realizados.",
    ifYouWantToSaveTheNewProviderInvoiceWithTheChangesMade: "si desea guardar la nueva factura de proveedor con los cambios realizados.",
    ifYouWantToSaveTheNewOrder: "si desea guardar el nuevo pedido.",
    ifYouWantToSaveTheNewOrderWithTheChangesMade: "si desea guardar el nuevo pedido con los cambios realizados.",
    companyPleaseEvaluateTheOrder: "empresa, evalúe el pedido.",
    ifYouWantToSaveTheNewInvoice: "si desea guardar la nueva factura.",
    youWillNotBeAbleToRemoveItFromThisCompany: ", no podrás eliminarlo de esta empresa, puedes seleccionar las otras empresas.",
    inThisCategory: "en esta categoría.",
    theCompanyContainTreasutyAccount: "la empresa debe contener al menos una cuenta de tesorería.",
    toBeAddedInOrderToDownloadTheInvoice: "ser agregada para descargar la factura.",

    // All sentence
    enterNewPassword: "Ingrese una nueva contraseña.",
    ifYouChangeYourMind: "Si cambia de opinión, solicite que se le envíe una nueva solicitud.",
    messageWillBeSentYourEmailToRecoverAccount:
      "Se enviará un mensaje a su correo electrónico para recuperar la cuenta, verifique su correo electrónico. Será redirigido a la página de inicio de sesión.",
    yuouCanNowStartUsingApp: "Ya puedes empezar a utilizar la aplicación, en breve serás redirigido a la página de inicio.",
    newCompanyIsSelectedByDefault: "La nueva empresa está seleccionada de forma predeterminada y se redirige a la página principal.",
    notificationWillBeDeleted: "Se eliminará la notificación de la invitación para acceder a la empresa.",
    theAppWillBeTranslated: "La aplicación se traducirá al idioma indicado, excepto la información ingresada en los documentos.",
    userWillRespondInvitation: "El usuario responderá si acepta o no la invitación para acceder a la empresa.",
    youWillNotBeAbleToUndo: "No podrás deshacer esta acción.",
    toValidateYourAccount: "Para validar tu cuenta, se enviará un mensaje a tu correo electrónico donde podrás verificarla.",
    pleaseCheckEmailToValidateAccount: "Por favor revisa tu correo, hemos enviado un mensaje para validar tu cuenta.",
    anEmailSentToValidateAccount: "Se te ha enviado un correo electrónico para validar tu cuenta.",
    validatedAccountForLoggedInUser: "Cuenta validada para el usuario que inició sesión, redirigir a la página principal.",
    validatedAccountForADifferentUser:
      "Cuenta validada para un usuario diferente al que está conectado, redirigir a la página de inicio de sesión.",
    validatedVerifiedForAUserWhoHasNotLoggedIn:
      "Validado verificado para un usuario que no ha iniciado sesión, redirigir a la página de inicio de sesión.",
    newServicesWithinTheSameApp: "Nuevos servicios dentro de la misma aplicación.",
    soonYouWillBeAbleToAccessNewFunctionalities: "Muy pronto podrás acceder a nuevas funcionalidades dentro de la aplicación.",
    pleaseCorrectThePathOfThePageInOrderToAccess: "Corrija la ruta de la página para acceder a la aplicación.",
    pleaseTryAgainLater: "Por favor, inténtalo de nuevo más tarde.",
    validTokenAutomaticLoginRedirectedDashboard: "Token válido, inició sesión automatico, redirigi a la página del dashboard.",
    redirectingToLogin: "Redireccionando a la página de inicio de sesión.",
    willNotBeAbleToReturnUntilYouLogin: "No podrá volver hasta que vuelva a iniciar sesión.",
    enterEmailWhetherBelongsRegisteredUserOrNot:
      "Ingresa el correo electrónico, ya sea de un usuario registrado o no. Se enviará una notificación para acceder a la aplicación y a la empresa, ya sea dentro de la aplicación (si el usuario existe) o al correo ingresado.",
    theFileMustBeFormat: "El archivo debe estar en formato jpeg, jpg o png.",
    ifYouHaveAnyQuestionsContactUs: "Si tiene alguna pregunta, puede contactarnos.",
    noNotificationsSeenYet: "No se han visto notificaciones todavía.",
    thereAreNoNotifications: "Aún no se han recibido notificaciones.",
    invitationsHaveNotReceived: "Aún no se han recibido invitaciones.",
    byDefaultValuesOfTheCompanyAreTaken: "Por defecto se toman valores de la empresa.",
    selectTheOptionsThatBestConsiderWhenDownloading:
      "Selecciona las opciones que mejor consideres a la hora de descargar una cotización o una factura en formato PDF.",
    notificationsAboutInvitationsToSubscribe: "Notificaciones sobre invitaciones para suscribirse y tener acceso a una empresa.",
    whenCreatingAContactByUUID:
      "Al crear un contacto por UUID no podrás modificar determinados campos según el tipo: persona (nombre, apellidos y email) y empresa (nombre).",
    youCanDirectlyEnterUUIDOfAUserOrCompanyToAddAsContact:
      "Puede ingresar directamente el UUID de un usuario o una empresa para agregarlo como contacto; de lo contrario, elija el tipo de contacto que desea crear.",
    descriptionCreateQuote: "Ingrese los siguientes datos, son necesarios para crear una nueva cotización.",
    descriptionCreateOrder: "Ingrese los siguientes datos, son necesarios para crear una nuevo pedido.",
    descriptionCreateInvoice: "Ingrese los siguientes datos, son necesarios para crear una nueva factura.",
    sorryLooksLikeThereAreSomeErrorstryAgain: "Lo sentimos, parece que se han detectado algunos errores, inténtalo de nuevo.",
    sorryLooksLikeThereAreSomeErrorsTrySolve: "Lo sentimos, parece que se han detectado algunos errores, intente resolverlos.",
    sorryThereIsNothingToAdd: "Lo sentimos, no hay nada que agregar, inténtalo de nuevo.",
    thankYouVeryMuchForSubscribingRedirectingToPreviousPage: "Muchas gracias por suscribirte, redirigiendo a la página anterior.",
    actionCompletedReturningToPage: "Acción completada, volviendo a la página.",
    actionCompletedRedirectingToPage: "Acción completada, redirigiendo a la página.",
    pleaseModifyAddOrDeleteFieldsFromQuote: "Por favor modifique, agregue y/o elimine los campos que desee de la cotización.",
    thisOptionIsUniqueAndNewOrderCannotBeCreatedFromThisQuote:
      "Esta opción es única y no se puede crear un nuevo pedido a partir de esta cotización.",
    descriptionCreateProviderInvoice: "Ingrese los siguientes datos, son necesarios para crear una nueva factura de proveedor.",
    pleaseModifyAddOrDeleteFieldsFromProviderInvoice: "Modifique, agregue y/o elimine los campos que desee de la factura del proveedor.",
    pleaseModifyAddOrDeleteFieldsFromExpense: "Modifique, agregue y/o elimine los campos que desee del gasto.",
    descriptionCreateExpense: "Por favor ingrese los siguientes datos, son necesarios para crear un nuevo gasto.",
    descriptionCreateProviderOrder: "Ingrese los siguientes datos, son necesarios para crear un nuevo pedido de proveedor.",
    pleaseModifyAddOrDeleteFieldsFromProviderOrder: "Modifique, agregue y/o elimine los campos que desee del pedido del proveedor.",
    fileFormatMaximum10MBPerFile: "El formato de archivo es '.pdf' y el tamaño máximo de archivo es de 10 MB.",
    someOfTheUploadedFilesDoNotMeetTheRequiredCharacteristics:
      "Algunos de los archivos cargados no cumplen con las características requeridas.",
    pleaseModifyAddOrDeleteFieldsFromOrder: "Modifique, agregue y/o elimine los campos que desee del pedido.",
    pleaseModifyAddOrDeleteFieldsFromInvoice: "Modifique, agregue y/o elimine los campos que desee de la factura.",
    thisAmountCanNotBeGreater: "Esta cantidad no puede ser mayor que la deuda total de la factura.",
    amountMinOfDueAndTransaction: "Mínimo entre el importe adeudado de la factura y el importe de la transacción.",
    toCreateAnDocument: "Para crear un documento, la empresa debe contener al menos una cuenta de tresorería.",
    newContactWwillAddedToCompanyAndSelectDefault: "New contact will be added to company and select as default, returning to page.",
    youHaveSuccessfullyResetYourPassword:
      "Ha restablecido con éxito su contraseña, ahora puede iniciar sesión nuevamente. Será redirigido a la página de inicio de sesión.",
    ifNoAmountIsEnteredTheValueWillBeZero: "Si no se ingresa ningun monto, el valor sera 0.",
    ifYouWishYouCanAssignNameInLanguagesNecessary: "Si lo deseas puedes asignar el nombre en los idiomas que consideres necesarios.",
    productNameRequiredAndRecommendedUnique: "Se requiere un nombre de producto y se recomienda que sea único.",
    addProductToCategory: "Agregar producto a una categoría.",
    addTagsToProduct: "Agregar etiquetas al producto, pueden ser opcionales.",
    setProductMediaGallery: "Configurar la galería multimedia del producto.",
    serviceNameRequiredAndRecommendedUnique: "Se requiere un nombre de servicio y se recomienda que sea único.",
    addServiceToCategory: "Agregar servicio a una categoría.",
    addTagsToService: "Agregar etiquetas al servicio, pueden ser opcionales.",
    setServiceMediaGallery: "Establecer la galería multimedia del servicio.",
    aCategoryContainServicesProducts: "Una categoria puede contener tanto servicios como productos.",
    ifSoAdditionalInformationRequired: "En caso afirmativo, se requerirá información adicional.",
    toPerformAnySubsequentActionWithInvoice:
      "Para realizar cualquier acción posterior con la factura, será necesario volver a validarla, especificando las cuentas contables correspondientes a cada producto y/o servicio asociado.",
    toPerformAnySubsequentActionWithProviderInvoice:
      "Para realizar cualquier acción posterior con la factura del proveedor, será necesario volver a validarla, especificando las cuentas contables correspondientes a cada producto y/o servicio asociado.",
    toPerformAnySubsequentActionWithExpense:
      "Para realizar cualquier acción posterior con el gasto, será necesario volver a validarlo, especificando las cuentas contables correspondientes a cada producto y/o servicio asociado.",
    toPerformAnyFurtherActionProviderOrder:
      "Para realizar cualquier otra acción con el pedido del proveedor, será necesario crear una copia del mismo.",
    validatingInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Al validar la factura, el sistema creará los siguientes asientos contables. Confirme las cuentas contables de cada servicio o producto de la factura.",
    validatingProviderInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Al validar la factura del proveedor, el sistema creará los siguientes asientos contables. Confirme las cuentas contables de cada servicio o producto de la factura del proveedor.",
    validatingExpenseSystemWillCreateToFollowingAccountingEntries:
      "Al validar el gasto, el sistema creará los siguientes asientos contables. Confirme las cuentas contables de cada servicio o producto del gasto.",
    allowedFileTypes: "Tipos de archivo permitidos: png, jpg, jpeg.",
    whenYouUploadPdfFilesTheyArePlacedReferenceSupplieIinvoiceCreationform:
      "Al cargar uno o varios archivos PDF, estos se ubican como referencia en el formulario de creación de factura del proveedor.",
    someFilesIncorrectlyFormattedAndTooLarge: "Algunos archivos tienen un formato incorrecto y otros son demasiado grandes.",
    someFilesIncorrectlyFormatted: "Algunos archivos tienen un formato incorrecto.",
    someFilesTooLarge: "Algunos archivos son demasiado grandes.",
    searchSelectContact: "Buscar y seleccionar un contacto.",
    accountingBookWithTotalAccountingEntriesCompany: "Libro contable con el total de entradas contables de la empresa.",
    byDefaultSimpleWriting: "Por defecto se crea una escrituta simple.",
    selectAllPossibleOptions: "Seleccione todas las opciones posibles.",
    newManualAccountingBookCreated: "Se creara un nuevo libro contable de tipo manual.",
    selectOptionToEnableForm: "Seleccione una opción para habilitar el formulario.",
    selectApplicableScheme: "Seleccione el régimen aplicable.",
    enterApplicableVatRate: "Ingrese la tasa de IVA aplicable.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderOrder:
      "El sistema está añadiendo los siguientes productos al inventario de la empresa. Confirme los centros de almacenamiento de cada producto en el pedido del proveedor.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderInvoice:
      "El sistema está añadiendo los siguientes productos al inventario de la empresa. Confirme los centros de almacenamiento de cada producto en el pedido del proveedor.",
    addPaymentUsingCashOrCardOrDeposit: "Añade un pago utilizando efectivo, tarjeta o depósito.",

    // Lowercase sentences
    yearl: "año",
    years: "años",
    hour: "hora",
    hours: "horas",
    minute: "minuto",
    minutes: "minutos",
    items: "elementos",
    groups: "grupos",
    selected: "seleccionado",
    accountNeedsA: "cuenta necesita",
    options: "opciones",
    with: "con",
    bestCustomers: "mejores clientes",
    byRecentUpdates: "por actualizaciones recientes",
    byTimeRange: "por rango de tiempo",
    template: "plantilla",
    evaluated: "evaluado",
    noMailFound: "no se encuentra ningún correo",
    report: "reporte",
    reports: "reportes",
    requestOnAccess: "solicitud de acceso a la empresa, su respuesta fue",
    userHasBeen: "ha sido",
    yourAnswerHasBeen: ", tu respuesta ha sido",
    toUser: "al usuario",
    hasBeen: "ha sido",
    byYear: "por año",
    or: "o",
    quotesToExpireThisMonth: "cotizaciones vencerán este mes",
    worstCustomers: "peores clientes",
    button: "botón",
    termsAndConditions: "términos y condiciones",
    and: "y",
    ourServicesOrRequesting: "nuestros servicios o solicitando uno nuevo",
    toAddOrRemoveCategory: "que desea agregar o eliminar a la categoría",
    orCall: "o al número",
    invoicesNotYetPaid: "facturas aún no pagadas",
    collections: "colecciones",
    from: "de",

    // Interrogative sentences
    isDeliveryAddressTheSameAsCustomersAddress: "¿La dirección de entrega es la misma que la dirección del cliente?",
    youWantLogOut: "¿Quieres cerrar la sesión?",
    doesItTakeALongTimeToLoadTheApp: "¿Toma mucho tiempo cargar la aplicación?",
    alreadyHaveAnCccount: "¿Ya tienes una cuenta?",
    forgotPassword: "¿Olvidó su contraseña?",
    newHere: "¿Nuevo aquí?",
    doYouWantToSendInvitation: "¿Deseas enviar una invitacion de acceso a la empresa?",
    selectThisTreasuryAccountAsTheMainOne: "¿Seleccionar esta cuenta de tesorería como la principal?",
    youWantToDeleteThisTreasuryAccount: "¿Desea eliminar esta cuenta de tesorería?",
    youWantToSelectThisTreasuryAccountAsPrimary: "¿Desea seleccionar esta cuenta de tesorería como principal?",
    wantToExtendChangesToOtherCompanies: "¿Quiere extender los cambios a otras empresas?",
    youWantToDeleteThisContact: "¿Quieres eliminar este contacto?",
    youWantToDeleteSelectedContacts: "¿Desea eliminar los contactos seleccionados?",
    youWantSendQuote: "¿Quiere enviar la cotización al cliente?",
    youWantToChangeQuoteStatusRejected: "¿Desea cambiar el estado de la cotización a rechazada?",
    youWantToGenerateAnOrderFromThisQuote: "¿Desea generar un pedido a partir de esta cotización?",
    youWantToChangeStatusTheExpense: "¿Quiere cambiar el estado del gasto?",
    youWantToDeleteThisDocument: "¿Desea eliminar este documento?",
    youWantToRevertThisDocumentToDraft: "¿Desea volver este documento a borrador?",
    youWantToDeleteThisExpense: "¿Desea eliminar este gasto?",
    youWantToChangeStatusTheProviderInvoice: "¿Quiere cambiar el estado de la factura del proveedor?",
    youWantToGenerateAProviderInvoiceFromThisProviderOrder: "¿Desea generar una factura de proveedor a partir de este pedido de proveedor?",
    youWantToChangeOrderStatusToCanceled: "¿Desea cambiar el estado del pedido a cancelado?",
    youWantToGenerateAnInvoiceFromThisOrder: "¿Desea generar una factura de este pedido?",
    youWantToSendTheOrderToCustomer: "¿Desea enviar el pedido al cliente?",
    youWantToCreateDeliveryNote: "¿Desea crear una nota de entrega?",
    aFullDeliveryNoteWillBeCreated: "Se creará una nota de entrega completa para todos los artículos de este pedido",
    youWantToSendDeliveryNote: "¿Desea enviar esta nota de entrega?",
    youWantToDeleteThisPayment: "¿Quiere eliminar este pago?",
    youWantToChangeStatusTheInvoice: "¿Quiere cambiar el estado de la factura?",
    isCompanyOwnerOfBankAccount: "¿La empresa es la titular de la cuenta bancaria?",
    useReferenceWithinQR: "¿Usar una referencia dentro del QR?",
    youWantDeleteProduct: "¿Quieres eliminar este producto?",
    youWantDeleteSelectedProducts: "¿Quieres eliminar los productos seleccionados?",
    youWantToDeleteThisReminder: "¿Quiere eliminar este recordatorio?",
    youWantToDeleteThisCategory: "¿Quieres eliminar esta categoría?",
    youWantToDeleteTheStorageCenter: "¿Quieres eliminar el centro de almacenamiento?",
    youWantToDeleteSelectedCategories: "¿Quieres eliminar categorías seleccionadas?",
    youWantToDeleteTheStorageCenters: "¿Quieres eliminar los centros de almacenamiento?",
    youWantDeleteService: "¿Quieres eliminar este producto?",
    youWantDeleteSelectedServices: "¿Quieres eliminar los servicios seleccionados?",
    isCompanySubjectVat: "¿Está la empresa sujeta al IVA?",
    wouldYouLikeUploadPdfFilesToRegistrationNnewInvoice:
      "¿Desea cargar uno o varios archivos PDF para facilitar el registro de un nueva factura?",
    howWouldLikeDeclareVat: "¿Cómo desea declarar el IVA?",
    youWantToDeleteThisPOS: "¿Deseas eliminar este POS?",
    doYouWantJoinNewCompany: "¿Desea acceder a la nueva empresa?",
    youWantToSendByEmail: "¿Desea enviar este documento por correo electrónico?",
    youWantToSendToCustomer: "¿Desea enviar esto al cliente?",
    youWantToDeleteThisAddress: "¿Desea eliminar esta dirección?",
    youWantToSetDefaultAddress: "¿Desea establecer esta dirección como predeterminada?",
    youWantToRejectQuote: "¿Desea rechazar esta cotización?",
    youWantToRejectOrder: "¿Desea rechazar este pedido?",

    // Exclamative sentences
    important: "¡Importante!",
    exclamError: "¡Error!",
    networkError: "Error de red",
    httpError: "Error HTTP",
    yourSessionHasBeenClosed: "¡Su sesión ha sido cerrada, por favor regístrese!",
    yourSessionHasExpired: "¡Su sesión ha caducado, regístrese de nuevo!",
    accountNotValidated: "¡Cuenta aún no validada!",
    newRegisteredUser: "¡Nuevo usuario registrado!",
    moneyBackGuarantee: "¡100% garantía de devolución de dinero!",
    somethingWentWrong: "¡Algo salió mal!",
    thePageYouLookedNotFound: "¡La página que buscó no se encuentra!",
    yourSessionIsActiveCongratulations: "Tu sesión está activa, ¡felicidades!",
    weNeedYourAttention: "¡Necesitamos su atención!",
    yourAreDone: "¡Terminaste!",
    startCreatingNewTreasuryAccountsForYourCompany:
      "¡Empiece a crear nuevas cuentas de tesorería para su empresa, es muy importante para el funcionamiento de la aplicación!",
    itNotChangeCompany: "¡No es posible cambiar de compañía!",
    weAreWorkingFeature: "¡Estamos trabajando en esta funcionalidad. Muy pronto estará disponible!",
    processOfCreatingANewInvoiceCompleted: "¡Proceso de creación de una nueva factura completado!",
    processOfUpdatingAInvoiceCompleted: "¡Proceso de actualización de una factura completado!",
    thereAreNoTreasuryAccounts: "¡No hay cuentas bancarias!",
    incorrectFiles: "¡Archivos incorrectos!",
    startAddingNewElementsToThisCategory: "¡Empieza a añadir nuevos elementos a esta categoría!",
    accountingAccountAlreadySelected: "¡Cuenta contable ya seleccionada, por favor seleccione otra!",
    servicesProductsWithTaxGreaterThanZero: "¡Servicios o productos con impuesto mayor a cero!",
    youHaveSuccessfullySignedOut: "¡Has cerrado sesión correctamente!",
    selectContactViewTheirAccountStatement: "¡Selecciona un contacto para visualizar su estado de cuenta!",
    processOfCreatingANewOrderCompleted: "¡Proceso de creación de un nuevo pedido completado!",
    processOfUpdatingAnOrderCompleted: "Proceso de actualización de un pedido completado",
    processOfCreatingQuoteCompleted: "¡Proceso de creación de una nueva cotización completado!",
    processOfCreatingAQuoteFromAnotherQuoteCompleted: "¡Se completó el proceso de creación de una cotización a partir de otra cotización!",
    processOfCreatingAOrderFromAnotherOrderCompleted: "¡Se completó el proceso de creación de una orden a partir de otra orden!",
    processOfCreatingAInvoiceFromAnotherInvoiceCompleted: "¡Se completó el proceso de creación de una factura a partir de otra factura!",
    processOfUpdatingAQuoteCompleted: "¡Proceso de actualización de una cotización completado!",
    processOfCreatingANewExpenseCompleted: "¡Proceso de creación de un nuevo gasto completado!",
    processOfUpdatingAnExpenseCompleted: "¡Proceso de actualización de un gasto completado!",
    processOfCreatingANewProviderInvoiceCompleted: "¡Proceso de creación de una nueva factura de proveedor completado!",
    processOfUpdatingAProviderInvoiceCompleted: "¡Proceso de actualización de una factura de proveedor completado!",
    processOfCreatedAProviderOrderCompleted: "¡Se completó el proceso de creación de un pedido de proveedor!",
    processOfCreatedAProviderInvoiceCompleted: "¡Se completó el proceso de creación de una factura de proveedor!",
    processOfCreatingANewProviderOrderCompleted: "¡Proceso de creación de un nuevo pedido de proveedor completado!",
    processOfUpdatingAProviderOrderCompleted: "¡Proceso de actualización de un pedido de proveedor completado!",
    successfullyCreatedAccountingAccount: "¡Cuenta contable creada exitosamente!",
    successfullyCreatedCategory: "¡Categoría creada exitosamente!",
    successfullyUpdatedCategory: "¡Categoría actualizada exitosamente!",
    successfullyInvitationSent: "¡Invitación enviada con éxito!",
    successfullyInvitationCancel: "¡La invitación se canceló con éxito!",
    successfullyCreatedContact: "¡Contacto creado con éxito!",
    successfullyUpdatedContact: "¡Contacto actualizado con éxito!",
    successfullyCreatedReminder: "¡Recordatorio creado con éxito!",
    successfullyUpdatedStatus: "¡Estado actualizado con éxito!",
    successfullyUpdatedReminder: "¡Recordatorio actualizado con éxito!",
    successfullyCreatedPayment: "¡Pago creado con éxito!",
    successfullyCreatedCompanyParameters: "¡Parámetros de la empresa creados con éxito!",
    successfullyUpdatedTreasuryAccount: "¡Cuenta de tresorería actualizada con éxito!",
    successfullyAcceptedInvitation: "¡Invitación aceptada con éxito!",
    successfullyLoggedIn: "¡Has iniciado sesión correctamente!",
    successfullyUpdatedCompanySettings: "¡Configuración de la empresa actualizada con éxito!",
    successfullyCreatedCompany: "¡Empresa creada con éxito!",
    successfullyDeletedPayment: "¡Pago eliminado con éxito!",
    successfullyCreatedInvoice: "¡Factura creada con éxito!",
    successfullyDeletedReminder: "¡Recordatorio eliminado con éxito!",
    successfullyOrderSent: "¡Pedido enviado con éxito!",
    successfullyQuoteSent: "¡Cotización enviada con éxito!",
    successfullyCreatedOrder: "Pedido creado con éxito!",
    successfullyCreatedDeliveryNote: "Nota de entrega creada con éxito!",
    successfullyDeliveryNoteSent: "Nota de entrega enviada con éxito!",
    successfullyCreatedTreasuryAccount: "¡Cuenta de tresorería creada con éxito!",
    successfullyUpdatedDefaultTreasuryAccount: "¡Cuenta de tresorería predeterminada actualizada con éxito!",
    successfullyDeletedDocument: "¡Documento eliminado con éxito!",
    successfullyDeletedTreasuryAccount: "¡Cuenta de tresorería eliminada con éxito!",
    successfullyCreatedAccountingEntry: "¡Entrada contable creada exitosamente!",
    successfullyUpdatedAccountingEntry: "¡Entrada contable actualizada exitosamente!",
    successfullyUpdatedBookingJournal: "¡Diario de contabilidad actualizado exitosamente!",
    successfulllyCreatedUser: "¡Usuario creado con éxito!",
    successfullyCreatedStorageCenter: "¡Centro de almacenamiento creado correctamente!",
    successfullyUpdatedStorageCenter: "¡Centro de almacenamiento actualizado correctamente!",
    successfullyCreatedStorageOperations: "¡Operaciones de almacenamiento creadas con éxito!",
    successfullyUpdatedPos: "¡POS creado exitosamente!",
    successfullyUpdatedUser: "¡Usuario actualizado con éxito!",
    successfullyAddedAddress: "¡Dirección agregada exitosamente!",
    successfullyUpdatedAddress: "¡Dirección actualizada exitosamente!",
    successfullyDeletedAddress: "¡Dirección eliminada exitosamente!",
    successfullySetDefaultAddress: "¡Dirección predeterminada establecida exitosamente!",
    successfullySentDocument: "¡Documento enviado exitosamente!",
    successfullyUpdated: "¡Actualizado exitosamente!",

    // Answer sentences
    okGotIt: "Ok, entendido",
    yesLogOut: "Sí, cerrar sesión",
    noCancel: "No, cancelar",
    noContinue: "No, continuar",
    yesDelete: "Si, eliminar",
    yesResolveError: "Sí, resolver el error",
    yesSelect: "Sí, seleccionar",
    yesCanceled: "Si, cancelar",
    okClose: "Ok, cerrar",
    yesReject: "Sí, rechazar",
    yesGenerate: "Sí, generar",
    yesSend: "Sí, enviar",
    yesChangeStatus: "Sí, cambiar estado",
    yesCreateTreasuryAccount: "Sí, crear cuenta de tresorería",
    yesValidate: "Si, validar",
    yesInvalidate: "Si, invalidar",
    yesUpload: "Si, cargar",
    noContinueForm: "No, continuar con el formulario",
    yesAdd: "Si, agregar",
    yesCreate: "Sí, crear",
    yesConfirm: "Sí, confirmar",

    // Suspensive sentences
    pleaseWait: "Por favor espere...",
    selectOption: "Seleccionar opción...",
    searchContact: "Buscar contacto...",
    searchCategory: "Buscar categoria...",
    searchProduct: "Buscar producto...",
    searchService: "Buscar servicio...",
    searchStorage: "Buscar centro de almacenamiento...",
    searchBookingJournal: "Buscar diario contable...",
    searchAccountingAccount: "Buscar cuenta contable...",
    select: "Seleccionar...",
    search: "Buscar...",
    writeCommentToInvite: "Escribe un comentario para la invitación...",
    loading: "Cargando...",
    roles: "Roles",
    noRolesAvailable: "No hay roles disponibles",
    noRolesDefinedForCompany: "No hay roles definidos para esta empresa.",
    noAssignableRoles: "Su rol no le permite asignar ningún rol. Contacte a un administrador.",
    roleNotAssignableByYou: "Su rol no le permite asignar este rol",
    roleAssignmentForbidden: "Su rol no permite asignar este rol",
    subscriptionExpiredAction: "Su suscripción ha expirado",
    system: "Sistema",
    administration: "Administración",
    admin: "Admin",
    member: "Miembro",
    assignedRoles: "Roles asignados",
    assignRole: "Asignar",
    removeRole: "Quitar",
    manageRoles: "Gestionar roles",
    revoke: "Revocar",
    reinvite: "Re-invitar",
    invite: "Invitar",
    role: "Rol",
    statusPending: "Pendiente",
    statusAccepted: "Aceptada",
    statusRejected: "Rechazada",
    statusExpired: "Expirada",
    expiresAt: "Expira el",
    noMembers: "No se encontraron miembros",
    confirmRevoke: "¿Está seguro de que desea revocar esta invitación?",
    confirmRemoveRole: "¿Está seguro de que desea quitar este rol?",
    policies: "Políticas",
    createRole: "Crear rol",
    createPolicy: "Crear política",
    attachedPolicies: "Políticas adjuntas",
    attachPolicy: "Adjuntar",
    detachPolicy: "Desadjuntar",
    statements: "Declaraciones",
    addStatement: "Agregar declaración",
    removeStatement: "Eliminar declaración",
    effect: "Efecto",
    allow: "Permitir",
    deny: "Denegar",
    actionsList: "Acciones",
    resources: "Recursos",
    resourcesHint: "Identificadores de recursos separados por comas, use * para todos",
    noRoles: "No se encontraron roles",
    noPolicies: "No se encontraron políticas",
    confirmDeleteRole: "¿Está seguro de que desea eliminar este rol?",
    confirmDeletePolicy: "¿Está seguro de que desea eliminar esta política?",
    systemReadOnly: "Este es un elemento del sistema y no se puede modificar",
    loadingCatalog: "Cargando catálogo de recursos...",
    emptyCatalog: "No hay recursos disponibles",
    advancedMode: "Avanzado",
    preview: "Vista previa",

    // Abbreviated sentences
    n: "N°",
    mb: "MB",
    hrs: "hrs",
    min: "min",
    sec: "seg",

    // Enumeration
    first: "primero",
    second: "segundo",
    third: "tercero",
    fourth: "cuarto",
    fifth: "quinto",
    sixth: "sexto",

    // Languages
    english: "Inglés",
    french: "Francés",
    italian: "Italiano",
    german: "Alemán",
    spanish: "Español",

    // Months
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre",

    // Periods
    monthly: "Mensual",
    quarterly: "Trimestral",
    semiannual: "Semestral",
    annual: "Anual",
    createAccount: "Crear cuenta",
    createSiblingAccount: "Crear cuenta hermana",
    createChildAccount: "Crear subcuenta",
    siblingOf: "Hermana de",
    subAccountOf: "Subcuenta de",
    nameFr: "Nombre (francés)",
    nameEn: "Nombre (inglés)",
    nameDe: "Nombre (alemán)",
    nameIt: "Nombre (italiano)",
    codeAndNameFrRequired: "El código y el nombre en francés son obligatorios",
    accountCreatedSuccessfully: "Cuenta creada con éxito",
    renameAccount: "Renombrar cuenta",
    accountRenamedSuccessfully: "Cuenta renombrada con éxito",
    siblingCodeHint: "4 dígitos — ej. 1005",
    childCodeHint: "XXXX.N — ej. 1000.01",
    siblingAccount: "Cuenta hermana",
    subAccount: "Subcuenta",
    referenceAccount: "Cuenta de referencia",
    creationMode: "Modo de creación",
    foreignCurrency: "Moneda extranjera",
    enableForeignCurrency: "Facturar en moneda extranjera",
    exchangeRate: "Tipo de cambio",
    exchangeDate: "Fecha del tipo",
    foreignCurrencyPreview: "Vista previa del monto convertido",
    convertedTotal: "Total convertido",
    rateInfo: "Info tipo de cambio",
    amountInCurrency: "Monto en {currency}",
    amountInCHF: "Monto CHF",
    partialBalance: "Parcial (sin conversión)",
    approxBalanceTooltip: "Línea(s) sin tipo de cambio — saldo {currency} aproximado",
    partialLinesFooter: "parcial ({count} líneas sin tipo)",
    currencyColumn: "Moneda",
    vatPeriodicity: "Periodicidad IVA",
    firstPeriod: "Primer período",
    deductionMethod: "Método de deducción",
    methodInvoicing: "Basado en facturación",
    methodCashing: "Basado en cobro",
    periodConfigured: "Períodos fiscales configurados",
    periodOpen: "Abierto",
    periodClosed: "Cerrado",
    periodFiled: "Presentado",
    closePeriod: "Cerrar período",
    taxSettingsLocked: "Los ajustes de IVA están bloqueados porque se ha creado un período fiscal. Para modificarlos, contacte a su fiduciario.",
    taxSettingsLockedContact: "Si desea cambiar el régimen de IVA, debe contactar a",
    period: "Período",
    format: "Formato",
    reconciliation: "Conciliación",
    bankStatements: "Extractos bancarios",
    importStatement: "Importar extracto",
    importBankStatement: "Importar extracto bancario",
    allTreasuryAccounts: "Todas las cuentas de tesorería",
    statementDate: "Fecha del extracto",
    openingBalance: "Saldo de apertura",
    closingBalance: "Saldo de cierre",
    importFailed: "Error en la importación",
    dragAndDropOrClick: "Arrastra un archivo aquí o haz clic para seleccionar",
    importing: "Importando...",
    importAction: "Importar",
    autoMatchInfo: "Después de la importación, se lanzará una conciliación automática para vincular las transacciones con las facturas existantes.",
    importSourceStructured: "Archivo estructurado (CAMT/CSV)",
    importSourcePdfUpload: "PDF — subir",
    importSourcePdfExisting: "PDF — documento existente",
    extractingStatement: "Extrayendo extracto…",
    preparingDocument: "Preparando documento…",
    extractionFailed: "La extracción ha fallado. Inténtelo de nuevo.",
    selectExistingDocument: "Seleccionar un documento existente",
    noPdfDocumentsAvailable: "No hay documentos PDF disponibles",
    retryExtraction: "Reintentar extracción",
    extractionTimeout: "La extracción está tardando más de lo esperado. Inténtelo más tarde.",
    jobQueued: "En cola...",
    jobFailed: "Fallido",
    heuristicSuggestions: "Sugerencias heurísticas",
    unmatchedLines: "Líneas no conciliadas",
    bankTransactions: "Transacciones",
    oneStatementNeedingAttention: "1 extracto necesita atención",
    statementsNeedingAttention: "extractos necesitan atención",
    someTransactionsNotReconciled: "Algunas transacciones aún no están conciliadas",
    continueReconciliation: "Continuar conciliación",
    finishReconciliation: "Terminar conciliación",
    counterpartIban: "IBAN contraparte",
    matchedVia: "Método",
    noTransactionsFound: "No se encontraron transacciones",
    viewStatement: "Ver extracto",
    alreadyImported: "Ya importada",
    overlapWarning: "Este período se superpone con {n} extracto(s) ya importado(s) para esta cuenta.",
    duplicatesUnchecked: "{x} transacción(es) ya presente(s) desmarcada(s) automáticamente.",
    includeLine: "Incluir",
    confirmed: "Validado",
    sortByPeriod: "Ordenar por período",
    confirmDeleteStatement: "¿Eliminar el extracto borrador?",
    confirmDeleteStatementText: "Este extracto borrador y su documento asociado se eliminarán permanentemente. Esta acción no se puede deshacer.",
    existingPayments: "Pagos existentes",
    linkThisPayment: "Vincular este pago",
    link: "Vincular",
    autoMatchAll: "Conciliación auto",
    exportTransactions: "Exportar transacciones",
    reconcile: "Conciliar",
    reconcileAutomatically: "Conciliar automáticamente",
    paid: "Pagada",
    entry: "Asiento",
    documentsToValidate: "Documentos por validar",
    validateAndReconcile: "Validar y conciliar",
    toValidate: "Por validar",
    dateFrom: "Desde",
    dateTo: "Hasta",
    resetFilters: "Restablecer",
    transactions: "transacciones",
    previous: "Anterior",
    next: "Siguiente",
    matched: "Conciliado",
    ignored: "Ignorado",
    relaunchAutoMatch: "Relanzar conciliación automática",
    matching: "Conciliación",
    starting: "Iniciando",
    jobRunning: "Conciliación automática en curso",
    linesProcessed: "Líneas procesadas",
    noLinesPending: "No hay líneas pendientes",
    matchManually: "Conciliar manualmente",
    match: "Conciliar",
    unmatch: "Anular conciliación",
    ignore: "Ignorar",
    noLinesInStatement: "No hay líneas en este extracto",
    statementNotFound: "Extracto no encontrado",
    confirmUnmatch: "¿Anular la conciliación de esta línea?",
    unmatchWillDeleteEntry: "El asiento contable asociado podría eliminarse.",
    yesUnmatch: "Sí, anular",
    confirmIgnore: "¿Ignorar esta línea?",
    yesIgnore: "Sí, ignorar",
    restoreLine: "Restaurar",
    lineRestored: "Línea restaurada a pendiente.",
    saveDraft: "Guardar",
    draftSaved: "Borrador guardado.",
    savingDraft: "Guardando…",
    unsavedChanges: "Cambios no guardados",
    unsavedChangesBody: "Tienes cambios sin guardar. ¿Qué deseas hacer?",
    quitWithoutSaving: "Salir sin guardar",
    statementNotDraft: "Este extracto ya no es un borrador. Recargando…",
    jobAlreadyRunning: "La conciliación automática ya está en curso",
    noCandidatesFound: "No se encontraron candidatos",
    score: "Puntuación",
    pending: "Pendiente",
    reconcileAndCollect: "Conciliar y cobrar",
    partialCollection: "cobro parcial",
    deleteStatement: "Eliminar extracto",
    confirmDeleteStatementTitle: "¿Eliminar este extracto bancario?",
    confirmDeleteStatementBody: "Esta acción elimina el extracto y sus {count} transacción(es) no conciliada(s).",
    statementDeleted: "Extracto eliminado con éxito.",
    cannotDeleteMatchedLines: "No se puede eliminar: {count} transacción(es) conciliada(s). Desvincule primero las conciliaciones.",
    cannotDeleteMatchedLinesTooltip: "No se puede eliminar: {count} transacción(es) conciliada(s). Desvincule primero las conciliaciones.",
    statementHasMatchedLinesError: "Este extracto tiene {count} transacción(es) conciliada(s). Desvincúlelas antes de eliminar.",
    invalidateStatement: "Invalidar",
    confirmInvalidateStatementTitle: "¿Invalidar este extracto bancario?",
    confirmInvalidateStatementBody: "El extracto volverá a borrador para corrección. Sus {count} transacción(es) ya no estarán disponibles para la conciliación. El documento importado permanece adjunto.",
    statementInvalidated: "Extracto vuelto a borrador.",
    confirmInvalidate: "Sí, invalidar",

    // VAT Return
    vatReturn: "Declaración de IVA",
    vatSectionTurnover: "I. Cifra de negocios",
    vatSectionTaxCalculation: "II. Cálculo del impuesto",
    vatSectionOtherFlows: "III. Otros movimientos de fondos",
    vatTaxDue: "Impuesto adeudado",
    vatInputTax: "Impuesto previo",
    vatBalance: "Saldo a favor de la AFC / del contribuyente",
    vatTax: "Impuesto",
    vatCaseComposition: "Composición de la casilla",
    vatCounterServices: "Contraprestaciones",
    vatDeductions: "Deducciones",
    vatTaxableTurnover: "Cifra de negocios imponible",
    vatAmountToPayAFC: "Importe a pagar a la AFC",
    vatBalanceInFavor: "Saldo a favor del contribuyente",
    vatTotalDeductions: "Total deducciones",
    vatTotalTaxDue: "Total impuesto adeudado",
    vatTotalInputTax: "Total impuesto soportado",
    vatNormalRate: "Prestaciones al tipo normal",
    vatReducedRate: "Prestaciones al tipo reducido",
    vatAccommodationRate: "Prestaciones al tipo especial",
    vatAcquisitions: "Impuesto sobre adquisiciones (neto, excl. IVA)",
    caseNumber: "Casilla",
    base: "Base",
    sign: "Signo",
    nature: "Naturaleza",
    reference: "Referencia",
    back: "Volver",
    accountingDocument: "Documento contable",
    documentNumber: "Número de documento",
    entryNumber: "Número de asiento",
    entryNumberShort: "N.º",
    manualEntry: "Asiento manual",
    createAndReconcile: "Crear y conciliar",
    gap: "Diferencia",
    editVatAdjustment: "Editar ajuste de IVA",
    noteOptional: "Nota (opcional)",
    vouchersSoonAvailable: "Comprobantes (próximamente)",
    periodIsFiledCannotEdit: "Este período está cerrado. Los ajustes no pueden ser modificados.",
    csvImport: "Importar CSV",
    difference: "Diferencia",
    balanced: "Equilibrado",
    unbalanced: "Desequilibrado",
    saveOpeningBalance: "Guardar balance de apertura",
    forceReprise: "Forzar apertura",
    forceRepriseWarning: "El ejercicio anterior está cerrado. Forzar sobrescribirá el asiento de apertura automático. ¿Está seguro?",
    csvFormatHelp: "Formatos CSV aceptados (separador punto y coma):",
    csvFormatBHelp: "1000;15000 (positivo = débito, negativo = crédito)",
    closedFiscalYearReadonly: "Este ejercicio está cerrado. El balance de apertura no puede ser modificado.",
    deleteOpeningBalance: "Eliminar balance de apertura",
    confirmDeleteOpeningBalance: "¿Está seguro de que desea eliminar el balance de apertura? Todos los importes se restablecerán.",
    amountMustBePositive: "El importe debe ser positivo — utilice la columna debe o haber.",

    // Period status transitions
    filePeriod: "Depositar",
    reopenPeriod: "Reabrir",
    confirmClosePeriod: "¿Está seguro de que desea cerrar este período? Los asientos no serán editables hasta que se reabra el período.",
    confirmFilePeriod: "¿Está seguro de que desea depositar este período? Esta acción es definitiva y no se puede deshacer.",
    confirmFilePeriodWarning: "Una vez depositado, la declaración de IVA quedará congelada y no será posible ninguna modificación.",
    confirmReopenPeriod: "¿Está seguro de que desea reabrir este período? Los asientos volverán a ser editables.",

    // Fiscal Years
    fiscalYears: "Ejercicios contables",
    fiscalYear: "Ejercicio contable",
    newFiscalYear: "Nuevo ejercicio",
    closeFiscalYear: "Cerrar ejercicio",
    closeFiscalYearConfirm: "¿Está seguro de que desea cerrar este ejercicio contable? Esta acción es irreversible. Todas las entradas quedarán bloqueadas y no será posible ninguna modificación.",
    closeFiscalYearWarning: "Esta acción es irreversible. Una vez cerrado, no se podrá añadir ni modificar ningún asiento para este ejercicio.",
    reopenFiscalYear: "Reabrir ejercicio",
    reopenFiscalYearConfirm: "¿Está seguro de que desea reabrir este ejercicio contable?",
    reopenFiscalYearWarning: "El asiento de cierre, el traspaso de apertura y la asignación del resultado del ejercicio siguiente serán eliminados. Los períodos serán reabiertos. Podrá volver a cerrar el ejercicio después.",
    reopenFiscalYearFirstReopen: "Reabra primero el ejercicio {name}",
    noFiscalYears: "No se encontraron ejercicios contables",
    createFiscalYear: "Crear ejercicio",
    editFiscalYear: "Editar ejercicio",
    deleteFiscalYear: "Eliminar ejercicio",
    confirmDeleteFiscalYear: "¿Está seguro de que desea eliminar definitivamente este ejercicio contable? Esta acción no se puede deshacer.",
    fiscalYearStartDate: "Fecha de inicio del ejercicio",
    fiscalYearClosingYear: "Año de cierre",
    fiscalYearEndDate: "Fecha de fin del ejercicio",
    fiscalYearEndForced: "El ejercicio contable siempre termina el 31 de diciembre",
    accountingSettingsInitializing: "Inicialización en curso…",

    // Annual correction
    annualCorrection: "Concordancia anual",
    createAnnualCorrection: "Crear concordancia anual",
    viewAnnualCorrection: "Ver concordancia",
    confirmCreateAnnualCorrection: "¿Crear la concordancia anual para este ejercicio? Los tickets huérfanos se asignarán a un nuevo período de concordancia.",
    periodsNotAllFiled: "Todos los períodos deben estar depositados antes de crear la concordancia anual.",
    noOrphans: "No hay tickets huérfanos que corregir para este ejercicio.",
    ticketsPending: "tickets pendientes",

    // Vouchers
    confirmDeleteVoucher: "¿Está seguro de que desea eliminar este justificante?",
    pendingUpload: "pendiente",
    uploadFailed: "La carga falló para uno o más archivos. El importe y la nota se han guardado.",
    addVoucher: "Añadir justificante",

    // Manual entries
    vatInputType: "Tipo de impuesto soportado",
    vatInputGoods: "Mercancías y material",
    vatInputInvestment: "Inversiones y otros gastos",
    deleteAccountingEntry: "Eliminar asiento",
    confirmDeleteAccountingEntry: "¿Está seguro de que desea eliminar este asiento?",

    // Financial statements
    balanceSheet: "Balance general",
    incomeStatement: "Estado de resultados",
    trialBalance: "Balance de comprobación",
    assets: "Activo",
    liabilities: "Pasivo",
    revenue: "Ingresos",
    netResult: "Resultado del ejercicio",
    asOfDate: "Al",
    previousYear: "Ejercicio anterior",
    variation: "Variación",
    notBalanced: "No equilibrado",
    sortByCode: "Ordenar por cuenta",
    sortByBalance: "Ordenar por saldo",
    allLevels: "Todos los niveles",
    profitOfYear: "Beneficio del ejercicio",
    lossOfYear: "Pérdida del ejercicio",
    viewList: "Lista",
    viewColumns: "Lado a lado",
    totalLiabilitiesAndResult: "Total pasivos y resultado",
    viewVouchers: "Ver comprobantes",
    pendingDocuments: "documento(s) pendiente(s)",
    showZeroAccounts: "Mostrar cuentas con saldo cero",
    hideZeroAccounts: "Ocultar cuentas con saldo cero",
    chatTitle: "Chat",
    chatConversations: "Conversaciones",
    chatNewConversation: "Nueva conversación",
    chatNoConversations: "Sin conversaciones",
    chatNoMessages: "Sin mensajes. ¡Di hola!",
    chatPlaceholder: "Escribe un mensaje...",
    chatSend: "Enviar",
    chatYou: "Tú",
    chatBack: "Volver",
    chatStartConversation: "Chat",
    chatSelectMember: "Seleccionar un miembro",
    chatLoadingMembers: "Cargando miembros...",
    chatNoMembers: "No se encontraron miembros",
    chatLoadingMessages: "Cargando mensajes...",
    chatActive: "Activo",
    featureLabelContacts: "Contactos & CRM",
    featureLabelSaleCore: "Ventas & facturación",
    featureLabelPurchaseCore: "Compras & facturas de proveedores",
    featureLabelTreasuryPayments: "Pagos & conciliación bancaria",
    featureLabelCatalog: "Catálogo de productos & servicios",
    featureLabelAccountingCore: "Contabilidad",
    featureLabelArchiveOcr: "Archivo de documentos & OCR",
    featureLabelNetworkInterbilling: "Facturación interempresarial",
    featureLabelPaymentOnline: "Pagos en línea",
    featureLabelDunning: "Cobros & recordatorios",
    featureLabelSaleRecurring: "Facturación recurrente",
    featureLabelTreasuryEbanking: "Conexión e-banking",
    featureLabelTreasuryForecast: "Previsión de tesorería",
    featureLabelProjectsTime: "Proyectos & control de tiempo",
    featureLabelPos: "Punto de venta",
    featureLabelExpenses: "Informes de gastos",
    featureLabelInventory: "Gestión de inventario",
    featureLabelSaleConsignment: "Ventas en consignación",
    featureLabelAccountingAssets: "Gestión de activos fijos",
    featureLabelServiceRepair: "Seguimiento de reparaciones",
    featureLabelRbacAdvanced: "Control de acceso avanzado",
    featureLabelMultiCompany: "Multi-empresa",
    featureLabelPayroll: "Nóminas",
    featureLabelStorefront: "Tienda en línea",
    featureLabelEsignature: "Firma electrónica",
    featureLabelMobileSale: "App móvil de ventas",
    featureLabelMobileExpenses: "Captura de gastos móvil",
    featureLabelSupportPriority: "Soporte prioritario",
    searchDocuments: "Buscar documentos",
    searchDocumentsPlaceholder: "Buscar documentos (nombre, contenido OCR)...",
    searchingDocuments: "Buscando...",
    searchDocumentsResultsCount: "{{count}} resultado(s) para \"{{query}}\"",
    searchDocumentsNoResults: "Sin resultados para \"{{query}}\"",
    filterDocumentStatus: "Estado del documento",
    filterDocumentDateFrom: "Fecha documento desde",
    filterDocumentDateTo: "Fecha documento hasta",
    filterUploadDateFrom: "Fecha de carga desde",
    filterUploadDateTo: "Fecha de carga hasta",
    statementToValidate: "Extracto por validar",
    draftMode: "Modo borrador",
    confirmImport: "Confirmar importación",
    extractedByVision: "Extraído por análisis de imagen",
    extractedByText: "Extraído por texto",
    reconciliationGapWarning: "Diferencia de {gap} — revise las líneas",
    confirmUnbalancedTitle: "Extracto no equilibrado",
    confirmUnbalancedText: "El extracto no está equilibrado. ¿Confirmar de todos modos?",
    ocrStatus: "Estado OCR",
    uploadedAt: "Subido el",
    pageXofN: "Página {page} de {pages}",
    filterByStatus: "Filtrar por estado",
    allStatuses: "Todos",
    statusNew: "Nuevo",
    statusAssigned: "Asignado",
    statusPartiallyProcessed: "Parcialmente procesado",
    statusProcessed: "Procesado",
    createFullInvoice: "Factura completa",
    depositInvoice: "Factura de anticipo",
    partialInvoice: "Factura parcial",
    depositAmount: "Monto del anticipo",
    depositDescription: "Descripción",
    quantityToInvoice: "Cantidad a facturar",
    remainingQuantity: "Restante",
    invoicedQuantity: "Facturado",
    totalQuantity: "Total",
    notInvoiced: "No facturada",
    partiallyInvoiced: "Parcialmente facturada",
    fullyInvoiced: "Totalmente facturada",
    invoicingStatus: "Estado de facturación",
    invoicedAmountOf: "facturado de",
    linkedInvoices: "Facturas vinculadas",
    noInvoicesYet: "No hay facturas por el momento",
    youWantToCreateDepositInvoice: "¿Desea crear una factura de anticipo?",
    youWantToCreatePartialInvoice: "¿Desea crear una factura parcial?",
    noLinesToInvoice: "No hay líneas para facturar",
    depositAmountExceedsRemaining: "El monto excede el saldo restante",
    manageStock: "Gestionar stock",
    stockManagedDescription: "Cada venta decrementará automáticamente el stock del centro de almacenamiento.",
    stockDisabledDescription: "No se generarán movimientos de stock para las ventas de esta caja.",
    stockManaged: "Stock gestionado",
    withoutStockManagement: "Sin gestión de stock",
    recipient: "Destinatario",
    emailSubject: "Asunto",
    emailMessage: "Mensaje",
    emailSent: "Correo enviado con éxito",
    emailDefaultMessage: "Adjunto encontrará el documento mencionado en el asunto.",
    correctAccounts: "Corregir cuentas",
    saveCorrection: "Guardar corrección",
    correctingAccountsDescription: "Puede corregir las cuentas de contrapartida de este documento. El asiento contable se actualizará en su lugar.",
    successfullyCorrectedAccounts: "Cuentas corregidas con éxito",

    // Payroll
    payroll: "Nóminas",
    payrollShort: "Nóminas",
    employees: "Empleados",
    addEmployee: "Añadir empleado",
    editEmployee: "Editar empleado",
    employeeNumber: "Número de empleado",
    searchEmployee: "Buscar empleado...",
    noEmployeesFound: "No se encontraron empleados",
    employeeStatusActive: "Activo",
    employeeStatusDraft: "Borrador",
    employeeStatusTerminated: "Cesado",
    workCanton: "Cantón de trabajo",
    activityRate: "Tasa de actividad",
    employmentContract: "Contrato de trabajo",
    avsNumber: "Número AVS",
    residencePermit: "Permiso de residencia",
    backToList: "Volver a la lista",
    backToDashboard: "Volver al panel",
    featureComingSoon: "Esta función estará disponible próximamente.",
    payrollAccessDenied: "Acceso denegado",
    payrollAccessDeniedOwnerOnly: "El módulo de nóminas está restringido al propietario de la empresa. Contacte a su administrador si cree que debería tener acceso.",
    payrollAccessDeniedReconnect: "Si sus permisos fueron actualizados recientemente, cierre sesión y vuelva a iniciarla para actualizar su sesión.",

    // Payroll forms
    identity: "Identidad",
    birthDate: "Fecha de nacimiento",
    gender: "Género",
    gender_male: "Masculino",
    gender_female: "Femenino",
    civilStatus: "Estado civil",
    civilStatus_single: "Soltero/a",
    civilStatus_married: "Casado/a",
    civilStatus_divorced: "Divorciado/a",
    civilStatus_widowed: "Viudo/a",
    civilStatus_registered_partnership: "Unión registrada",
    civilStatus_dissolved_partnership: "Unión disuelta",
    civilStatusSince: "Estado civil desde",
    civilStatusSinceHelp: "Determina la escala de retención fiscal aplicable. Un cambio de estado civil entra en vigor el mes siguiente al evento.",
    nationality: "Nacionalidad",
    permitType: "Tipo de permiso",
    permitNumber: "Número de permiso",
    permitValidUntil: "Válido hasta",
    issuingCanton: "Cantón emisor",
    swissNational: "Nacional suizo",
    permit: "Permiso",
    residence: "Residencia",
    canton: "Cantón",
    municipality: "Municipio",
    familySituation: "Situación familiar",
    hasSpouse: "Tiene cónyuge / pareja registrada",
    spouseIsWorking: "El cónyuge trabaja",
    spouseWorkCanton: "Cantón de trabajo del cónyuge",
    spouseWorkCountry: "País de trabajo del cónyuge",
    children: "Hijos",
    addChild: "Añadir hijo",
    child: "Hijo",
    allowanceFrom: "Asignación desde",
    allowanceTo: "Asignación hasta",
    inEducation: "En formación",
    paymentDetails: "Datos de pago",
    bic: "BIC/SWIFT",
    accountHolder: "Titular de la cuenta",
    notes: "Notas",
    linkedContact: "Contacto vinculado",
    searchContact: "Buscar un contacto existente...",
    contactRequired: "Seleccione un contacto",
    refreshSnapshot: "Actualizar datos del contacto",
    change: "Cambiar",

    // Contract form
    contractHistory: "Historial de contratos",
    addContractVersion: "Añadir versión de contrato",
    newContractVersion: "Nueva versión de contrato",
    editContract: "Editar contrato",
    newVersionWarning: "Se creará la versión {version} del contrato, vigente a partir de la fecha indicada. La versión {prevVersion} se cerrará automáticamente.",
    contractType: "Tipo de contrato",
    contractType_permanent: "Indefinido",
    contractType_fixed_term: "Determinado",
    contractType_apprenticeship: "Aprendizaje",
    contractType_internship: "Prácticas",
    salaryMode: "Modo salarial",
    salaryMode_monthly: "Mensual",
    salaryMode_hourly: "Por hora",
    hireDate: "Fecha de contratación",
    endReason: "Motivo de cese",
    weeklyHours: "Horas semanales",
    probationMonths: "Período de prueba (meses)",
    noticePeriod: "Preaviso (meses)",
    salary: "Salario",
    baseSalary: "Salario base",
    thirteenthSalary: "Paga extra",
    thirteenthMode: "Modo de pago",
    thirteenthMode_december: "Diciembre",
    thirteenthMode_monthly_provision: "Provisión mensual",
    thirteenthModeHelp: "Pago en diciembre — el salario 13.º se paga íntegramente en diciembre. En caso de salida durante el año, la parte devengada se paga en la liquidación final.\n\nProvisión mensual — una doceava parte se paga cada mes con la nómina corriente. Sin pago en diciembre.",
    vacation: "Vacaciones",
    vacationDays: "Días por año",
    vacationRate: "Suplemento vacaciones (%)",
    workplace: "Lugar de trabajo",
    workplaceAddressCompany: "Dirección de la empresa",
    workplaceAddressOther: "Otra dirección",
    validFrom: "Vigente desde",
    validTo: "Hasta",
    version: "Versión",
    current: "Actual",
    closed: "Cerrado",
    future: "Futuro",
    noContracts: "Aún no hay contratos",
    // Contract termination
    terminateContract: "Rescindir contrato",
    confirmTermination: "Confirmar rescisión",
    terminationConsequences: "La rescisión del contrato tendrá los siguientes efectos:",
    terminationStatusChange: "El estado del empleado cambiará a <strong>rescindido</strong>",
    terminationFinalSettlement: "Se producirá una <strong>liquidación final</strong> en el período de nómina que contenga esta fecha",
    terminationExclusion: "El empleado será <strong>excluido de los ciclos de nómina posteriores</strong>, excepto para ajustes retroactivos",
    terminationWarning: "La rescisión de un contrato genera una liquidación final en el período de nómina que contiene la fecha de fin. Esta acción puede cancelarse antes de la validación del ciclo de nómina.",
    contractTerminated: "Contrato rescindido",
    cancelTermination: "Cancelar rescisión",
    cancelTerminationConfirm: "¿Está seguro de que desea cancelar esta rescisión? El empleado volverá al estado activo.",
    terminationCancelled: "Rescisión cancelada",
    terminated: "Rescindido",
    endReason_resignation: "Dimisión",
    endReason_dismissal: "Despido",
    endReason_mutual_agreement: "Acuerdo mutuo",
    endReason_end_of_term: "Fin del término",
    endReason_retirement: "Jubilación",
    endReason_death: "Fallecimiento",
    endReason_disability: "Invalidez",
    endReason_probation: "Fin del período de prueba",

    // Payroll — Company salary settings
    salarySettings: "Configuración salarial",
    insurancePlans: "Planes de seguro",
    payrollSettings: "Configuración de nómina",
    payrollCompleteness: "Estado de preparación",
    payrollCompletenessOk: "Todos los ajustes necesarios están configurados. La nómina puede calcularse.",
    payrollCompletenessMissing: "Los siguientes ajustes deben completarse antes de calcular la nómina:",
    insurancePlanType_laap: "LAA Profesional (LAAP)",
    insurancePlanType_laanp: "LAA No profesional (LAANP)",
    insurancePlanType_laac: "LAA Complementario (LAAC)",
    insurancePlanType_ijm: "Seguro de enfermedad diario (IJM)",
    insurancePlanType_lpp: "Previsión profesional (LPP)",
    insurerName: "Nombre del asegurador",
    policyNumber: "Número de póliza",
    rateEmployee: "Tasa empleado (%)",
    rateEmployer: "Tasa empleador (%)",
    riskClass: "Clase de riesgo",
    lppRatesByAge: "Tasas por grupo de edad",
    lppAgeFrom: "Desde edad",
    lppAgeTo: "Hasta edad",
    addAgeBracket: "Añadir grupo de edad",
    coordinationDeductionOverride: "Deducción de coordinación (override)",
    entryThresholdOverride: "Umbral de entrada (override)",
    addInsurancePlan: "Añadir plan de seguro",
    editInsurancePlan: "Editar plan de seguro",
    noInsurancePlans: "Aún no hay planes de seguro",
    effectiveSince: "Vigente desde el {date}",
    closurePlanWarning: "Este plan entrará en vigor el {date}. El plan {type} actual se cerrará el {closureDate}.",
    confirmDeletePlan: "¿Está seguro de que desea eliminar este plan de seguro?",
    deletePlan: "Eliminar plan",
    avsFund: "Caja AVS",
    avsFundName: "Nombre de la caja",
    avsMemberNumber: "Número de afiliado",
    avsAdministrationRate: "Tasa de administración (%)",
    familyAllowanceFund: "Caja de asignaciones familiares",
    familyAllowanceFundName: "Nombre de la caja",
    familyAllowanceMemberNumber: "Número de afiliado",
    withholdingTax: "Impuesto en la fuente",
    withholdingTaxCanton: "Cantón fiscal",
    withholdingTaxDebtorNumber: "Número de deudor",
    withholdingTaxPeriodicity: "Periodicidad de declaración",
    periodicityMonthly: "Mensual",
    periodicityQuarterly: "Trimestral",
    periodicityAnnual: "Anual",
    payFrequency: "Frecuencia de pago",
    payFrequencyMonthly: "Mensual",
    payFrequencySemiMonthly: "Quincenal",
    payFrequencyWeekly: "Semanal",
    missingActiveLaap: "Plan LAAP activo con tasa de empleador",
    missingActiveLaanp: "Plan LAANP activo con tasa de empleado",
    missingActiveLpp: "Plan LPP activo con grupos de edad",
    missingAvsFundName: "Nombre de la caja AVS",
    missingAvsAdminRate: "Tasa de administración AVS",
    missingFamilyAllowanceFundName: "Nombre de la caja de asignaciones familiares",
    missingAvsAdminBase: "Base de cálculo de gastos administrativos AVS",
    missingFamilyAllowanceRate: "Tasa de cotización asignaciones familiares",
    administrationBase: "Base de cálculo de gastos",
    administrationBaseAvsContributions: "Cotizaciones AVS/AI/APG",
    administrationBaseGrossAvs: "Masa salarial sujeta a AVS",
    administrationBaseHelp: "Según su caja, la tasa se aplica al total de cotizaciones AVS/AI/APG o a la masa salarial bruta sujeta a AVS. Esta información figura en su extracto de caja.",
    familyAllowanceContributionRate: "Tasa de cotización del empleador",
    familyAllowanceRateHelp: "Esta tasa depende de la caja de afiliación, no del cantón. Dos empresas en el mismo cantón afiliadas a cajas diferentes pagan tasas diferentes.",
    expenseRegulation: "Reglamento de gastos",
    expenseRegulationApproved: "Reglamento de gastos aprobado",
    expenseRegulationCanton: "Cantón de aprobación",
    expenseRegulationDate: "Fecha de aprobación",
    expenseRegulationReference: "Número de referencia",
    withholdingTaxNote: "La configuración del impuesto en la fuente es parcial. El soporte completo (consulta de baremos, correcciones anuales) está previsto para una versión futura.",
    showPlanHistory: "Mostrar historial",
    hidePlanHistory: "Ocultar historial",

    // Payroll — Payroll runs
    payrollRuns: "Ciclos de nómina",
    payrollRun: "Ciclo de nómina",
    payslip: "Nómina",
    payslips: "Nóminas",
    openPeriod: "Abrir período",
    period: "Período",
    employeeCount: "Empleados",
    grossTotal: "Bruto",
    netTotal: "Neto",
    employerCost: "Coste del empleador",
    totalDeductions: "Deducciones",
    totalEmployerCharges: "Cargas patronales",
    validatedAt: "Validado el",
    calculate: "Calcular",
    recalculate: "Recalcular",
    validate: "Validar",
    markAsPaid: "Marcar como pagado",
    cancelRun: "Anular",
    regeneratePdfs: "Regenerar PDFs",
    downloadSummary: "Descargar resumen",
    downloadPayslip: "Descargar nómina",
    calculating: "Calculando...",
    calculatingProgress: "Cálculo en curso. Puede tardar unos minutos.",
    calculatingTimeout: "El cálculo está tardando más de lo esperado. Puede reintentar.",
    retryCalculation: "Reintentar cálculo",
    noPayrollRuns: "Aún no hay ciclos de nómina",
    noPayslips: "Sin nóminas",
    createPayrollRun: "Abrir un período de nómina",
    periodAlreadyExists: "Ya existe un ciclo de nómina para este período.",
    periodAlreadyExistsLink: "Ver ciclo existente",
    confirmValidateTitle: "Validar ciclo de nómina",
    confirmValidateBody: "{count} nóminas — Bruto: {gross} — Neto: {net} — Coste empleador: {employerCost}",
    confirmValidateIrreversible: "Esta acción es irreversible. Las nóminas se congelarán y los PDFs se generarán. Cualquier corrección requerirá una anulación o un ajuste retroactivo.",
    confirmValidateFinalSettlements: "Este ciclo contiene {count} liquidación(es) final(es).",
    confirmValidateNegativeNets: "Este ciclo contiene {count} nómina(s) con neto negativo.",
    confirmCancelTitle: "Anular ciclo de nómina",
    cancellationReason: "Motivo de anulación",
    cancellationReasonRequired: "Se requiere un motivo para anular un ciclo de nómina.",
    confirmPayTitle: "Marcar como pagado",
    confirmPayBody: "Confirmar que {count} nóminas por un total de {net} neto han sido pagadas.",
    payslipProvisional: "Provisional — no validado",
    provisional: "Provisional",
    interim: "Intermedio",
    ancillaryActivities: "Actividades accesorias",
    extraordinaryItems: "Partidas extraordinarias",
    payslipFailed: "Cálculo fallido",
    controlPanel: "Panel de control",
    failedPayslips: "Nóminas con error",
    failedPayslipsBlocking: "Validación bloqueada: {count} nómina(s) con error.",
    excludedEmployees: "Empleados excluidos",
    runWarnings: "Advertencias",
    finalSettlements: "Liquidaciones finales",
    negativeNets: "Netos negativos",
    retroactiveOnly: "Solo retroactivos",
    runStatusDraft: "Borrador",
    runStatusCalculating: "Calculando",
    runStatusCalculated: "Calculado",
    runStatusValidated: "Validado",
    runStatusPaid: "Pagado",
    runStatusCancelled: "Anulado",
    exclusionStatusDraft: "Empleado en estado borrador",
    exclusionStatusTerminated: "Relación laboral terminada",
    exclusionNoContract: "Sin contrato activo",
    exclusionHireAfterPeriod: "Contratado después del período",
    exclusionContractEndedBeforePeriod: "Contrato terminado antes del período",
    warningLppNotVerifiableHourly: "Las cotizaciones LPP no pudieron verificarse para los empleados por hora",
    warningPdfGenerationFailed: "La generación del PDF falló para esta nómina",
    warningHasAbsence: "Este empleado tiene ausencias durante el período",
    warningHourlyAbsenceNotDeducted: "Empleado por hora con ausencias — la deducción no se aplica automáticamente",
    warningHourlyZeroGross: "Empleado por hora con salario bruto cero",

    // Monthly declaration
    monthlyDeclaration: "Declaración mensual",
    monthlyDeclarations: "Declaraciones mensuales",
    socialInsuranceDays: "Días AS",
    absenceDays: "Días de ausencia",
    effectiveWorkingDays: "Días de trabajo efectivos",
    workingHours: "Horas",
    absences: "Ausencias",
    addAbsence: "Agregar una ausencia",
    editAbsence: "Editar la ausencia",
    deleteAbsence: "Eliminar la ausencia",
    absenceOngoing: "En curso",
    daysRetained: "{days} día(s) retenido(s)",
    declarationValidated: "Validada",
    declarationDraft: "Borrador",
    validateDeclaration: "Validar la declaración",
    validateAllDeclarations: "Validar todas",
    saveDeclaration: "Guardar",
    noEligibleEmployees: "Ningún empleado elegible para este ciclo",
    hourlyNoHoursWarning: "Empleado por hora sin horas ingresadas — la nómina será cero",
    declarationNotValidated: "Declaración no validada",
    recalculationNeeded: "Las variables salariales han sido modificadas desde el último cálculo. Es necesario recalcular antes de validar.",
    loadError: "Error al cargar los datos",
    retry: "Reintentar",
    punctualRubriques: "Partidas puntuales",
    addRubrique: "Agregar una partida",
    removeRubrique: "Eliminar",
    rubriqueCode: "Código",
    rubriqueLabel: "Etiqueta",
    rubriqueAmount: "Monto",
    rubriqueQuantity: "Cantidad",
    rubriqueRate: "Tasa",
    rubriqueCalculationMode: "Modo de cálculo",
    declarationFor: "Declaración de {name}",
    backToRun: "Volver al ciclo",
    editDeclaration: "Ingrese las variables",
    activityRate: "Tasa de actividad",
    noRubriques: "Sin rúbricas puntuales",
    saveAndClose: "Guardar y cerrar",

    // Absence reasons
    absenceReason: "Motivo de ausencia",
    absenceReasonIllness: "Enfermedad",
    absenceReasonAccidentOccupational: "Accidente laboral",
    absenceReasonAccidentNonOccupational: "Accidente no laboral",
    absenceReasonMilitaryService: "Servicio militar",
    absenceReasonMaternity: "Maternidad",
    absenceReasonPaternity: "Paternidad",
    absenceReasonUnpaid: "Ausencia no remunerada",
    absenceReasonUnjustified: "Ausencia injustificada",
    incapacityRate: "Tasa de incapacidad",
    salaryContinuationRate: "Continuación del salario",
    absenceFrom: "Desde",
    absenceTo: "Hasta",
    absenceToHelp: "Dejar vacío si la ausencia está en curso",
    confirmDeleteAbsence: "¿Está seguro de que desea eliminar esta ausencia?",

    // Absence report
    absenceReport: "Informe de ausencias",
    absenceHistory: "Historial de ausencias",
    totalByReason: "Total por motivo",
    noAbsences: "Sin ausencias",
    filterByYear: "Filtrar por año",
    filterByReason: "Filtrar por motivo",
    allReasons: "Todos los motivos",
    goToPayrollRun: "Ver ciclo de nómina",
    companySnapshotIncomplete: "Los datos de la empresa están incompletos (falta nombre, dirección o número IDE). Los PDF de nóminas podrían verse afectados.",
    companySettings: "Ir a la configuración de la empresa",
    validateBlockedByFailures: "Validación imposible: hay nóminas con error",
    backToPayrollRuns: "Volver a los ciclos de nómina",
    year: "Año",

    // Zod error map
    zodFieldRequired: "Este campo es obligatorio",
    zodInvalidType: "Valor no válido",
    zodTooShort: "Mínimo {min} caracteres",
    zodTooLong: "Máximo {max} caracteres",
    zodNumberTooSmall: "Debe ser al menos {min}",
    zodNumberTooBig: "Debe ser como máximo {max}",
    zodArrayTooShort: "Se requiere(n) al menos {min} elemento(s)",
    zodInvalidEmail: "Dirección de correo no válida",
    zodInvalidFormat: "Formato no válido",
    zodInvalidSelection: "Seleccione una opción válida",
    zodInvalidDate: "Fecha no válida",
    zodInvalidValue: "Valor no válido",

    // Reconciliation indicators
    reconciled: "Conciliado",
    notReconciled: "No conciliado",
    filteredTotalsWarning: "Los totales corresponden al filtro activo, no a la cuenta completa",

    // Recurring contracts
    recurringContracts: "Contratos recurrentes",
    recurringContract: "Contrato recurrente",
    addRecurringContract: "Agregar contrato recurrente",
    createRecurringContract: "Crear contrato recurrente",
    updateRecurringContract: "Modificar contrato recurrente",
    viewRecurringContract: "Detalles del contrato recurrente",
    searchRecurringContract: "Buscar contrato...",
    allStatuses: "Todos los estados",
    frequency: "Frecuencia",
    monthly: "Mensual",
    quarterly: "Trimestral",
    semiAnnual: "Semestral",
    annual: "Anual",
    nextInvoiceDate: "Próxima factura",
    generateInvoice: "Generar factura",
    generateInvoiceConfirm: "Se creará una factura a partir de este contrato.",
    invoiceGenerated: "Factura generada",
    generatedInvoices: "Facturas generadas",
    pause: "Pausar",
    paused: "Pausado",
    activate: "Activar",
    changeStatusTo: "Cambiar estado a",
    ended: "Finalizado",
    every: "Cada",
    quarters: "trimestres",
    anchorDay: "Día del mes",
    issueOffsetDays: "Anticipo de emisión (días)",
    autoValidate: "Validación automática",
    autoSend: "Envío automático",
    autoBilling: "Facturación automática (validar y enviar)",
    autoBillingRequiresAccount: "El servicio seleccionado no tiene una cuenta contable configurada; la facturación automática requiere una cuenta.",
    autoRenew: "Renovación automática",
    autoRenewHint: "Renovar automáticamente el contrato al vencimiento",
    renewDaysBefore: "Días antes del vencimiento",
    renewDaysBeforeHint: "Número de días antes del vencimiento para activar la renovación automática",
    renewNow: "Renovar ahora",
    renewConfirm: "El contrato se extenderá por un período adicional.",
    contractRenewed: "Contrato renovado",
    lifecycleHistory: "Historial del ciclo de vida",
    eventRenewed: "Renovado",
    eventEnded: "Finalizado",
    triggerAuto: "Automático",
    triggerManual: "Manual",
    noLifecycleEvents: "Sin eventos",
    renewalCount: "Renovaciones",
    paymentTermsDays: "Plazo de pago (días)",

    // Bank statement extraction retry
    retryExtraction: "Reintentar extracción",
    extractionFailedRetry: "La extracción falló. Puede reintentar.",
    extractionEmptyRetry: "Extracción completada pero no se encontraron líneas. Puede reintentar.",
    extractionInProgress: "Extracción en curso…",
    retrying: "Reintentando…",

    // Dunning policies
    dunningPolicies: "Políticas de cobro",
    dunningLabelRequired: "El nombre de la política es obligatorio",
    dunningStepsRequired: "Se requiere al menos un paso",
    editDunningPolicy: "Editar política de cobro",
    addDunningPolicy: "Añadir política de cobro",
    appliesTo: "Se aplica a",
    both: "Ambos",
    setAsDefault: "Política por defecto",
    stopAfterLastStep: "Detener después del último paso",
    dunningSteps: "Pasos de cobro",
    addStep: "Añadir paso",
    step: "Paso",
    offsetDays: "Desfase (días desde vencimiento)",
    offsetDaysHint: "Negativo = antes del vencimiento (recordatorio de cortesía)",
    channel: "Canal",
    escalationTone: "Tono",
    templateKey: "Clave de plantilla",
    toneNeutral: "Neutro",
    toneFirm: "Firme",
    toneFormal: "Formal",
    addLateFee: "Añadir recargos por mora",
    lateFeeType: "Tipo de recargo",
    lateFeeFixed: "Importe fijo",
    lateFeeInterest: "Interés de mora",
    lateFeeBoth: "Fijo + interés",
    lateFeeLabel: "Etiqueta en factura",
    fixedAmount: "Importe fijo",
    annualRate: "Tasa anual (%)",
    interestBase: "Base de cálculo",
    basePrincipal: "Importe principal",
    baseCurrent: "Importe actual",
    dunningPolicy: "Política de cobro",
    noDunning: "Sin cobro",
    dunningPolicyHint: "Seleccione la política de cobro para este documento",
    dunningConfigured: "Configurada",
    dunningRelances: "Cobros",
    dunningActive: "Activos",
    dunningSuspended: "Suspendidos",
    dunningStopped: "Detenidos",
    dunningUntil: "hasta",
    lateFee: "Gastos",
    noDunningSent: "Ningún cobro enviado por el momento.",
    suspendDunning: "¿Suspender los cobros?",
    resumeDunning: "Reanudar",
    stopDunning: "¿Detener definitivamente los cobros?",
    yesStop: "Sí, detener",
    dunningWillPause: "Los cobros automáticos se pausarán para esta factura.",
    dunningStopIrreversible: "Esta factura nunca más será cobrada automáticamente.",
    dunningResumed: "Cobros reanudados",

    // Subscription banner
    subscriptionTrialBanner: "Su prueba gratuita finaliza el {date} ({days} días restantes)",
    subscriptionPastDueBanner: "Su factura está impaga. Por favor, regularice antes del {date} para evitar una interrupción del servicio",
    subscriptionExpiredBanner: "Su suscripción ha expirado. El acceso es de solo lectura. Renueve para restaurar el acceso completo",
    subscriptionCancelledBanner: "Su suscripción finaliza el {date}",
    subscriptionDaysRemaining: "{days} días restantes",
    subscriptionPayNow: "Pagar ahora",
    subscriptionChoosePlan: "Elegir un plan",

    // Subscription & plan labels
    subscription: "Suscripción",
    featureNotIncluded: "No incluido en su plan actual",
    featureRequiresPlan: "Disponible a partir del plan {plan}",
    featureRequiresActiveSubscription: "Se requiere una suscripción activa",
    featureViewOffers: "Ver planes",
    featureRegularize: "Renovar suscripción",
    featureContactAdmin: "Contacte a su administrador para cambiar de plan",

    // Subscription management (F2)
    subscriptionMySubscription: "Mi suscripción",
    subscriptionOffers: "Planes y precios",
    subscriptionCurrentPlan: "Plan actual",
    subscriptionFreePlan: "Gratuito",
    subscriptionBillingCycle: "Ciclo de facturación",
    subscriptionNextRenewal: "Próxima renovación",
    subscriptionTrialEndsOn: "La prueba finaliza el {date}",
    subscriptionTrialDaysLeft: "{days} días restantes en su prueba",
    subscriptionPendingChange: "Cambio pendiente",
    subscriptionPendingChangeDetail: "Cambiará a {plan} el {date}",
    subscriptionCancelPendingChange: "Cancelar este cambio",
    subscriptionPendingChangeCancelled: "Cambio pendiente cancelado",
    subscriptionCancelPendingConfirmTitle: "¿Cancelar el cambio de plan?",
    subscriptionCancelPendingConfirmText: "Su suscripción permanecerá en el plan {currentPlan}. El cambio al plan {pendingPlan} no se llevará a cabo.",
    subscriptionQuotas: "Uso y cuotas",
    subscriptionQuotaUsage: "{current} / {limit}",
    subscriptionUnlimited: "Ilimitado",
    subscriptionChangePlan: "Cambiar de plan",
    subscriptionChooseMyOffer: "Elegir mi plan",
    subscriptionPayMyInvoice: "Pagar mi factura",
    subscriptionAnnualSavingsHint: "Ahorre {percent}% con la facturación anual",
    subscriptionCancelSubscription: "Cancelar suscripción",
    subscriptionReactivate: "Reactivar",
    subscriptionCancelConfirmTitle: "¿Cancelar su suscripción?",
    subscriptionCancelConfirmText: "Conservará el acceso hasta el final del período actual. Después, su suscripción no se renovará.",
    subscriptionCancelledSuccess: "Su suscripción ha sido cancelada",
    subscriptionReactivatedSuccess: "Su suscripción ha sido reactivada",
    subscriptionUpgrade: "Mejorar plan",
    subscriptionDowngrade: "Reducir plan",
    subscriptionUpgradeConfirmTitle: "¿Cambiar a {plan}?",
    subscriptionUpgradeConfirmText: "Este cambio tiene efecto inmediato. Se le cobrará la diferencia prorrateada.",
    subscriptionDowngradeConfirmTitle: "¿Cambiar a {plan}?",
    subscriptionDowngradeConfirmText: "Su plan cambiará a {plan} el {date}. Conserva todas las funciones actuales hasta entonces.",
    subscriptionChangeSuccess: "Su plan ha sido actualizado",
    subscriptionEffectImmediate: "Efecto inmediato",
    subscriptionEffectAtDate: "Efectivo el {date}",
    subscriptionYouWillBeCharged: "Importe a cobrar: {amount}",
    subscriptionProrataNotice: "Se le cobrará la tarifa prorrateada",
    subscriptionCompareOffers: "Comparar planes",
    subscriptionYourCurrentPlan: "Su plan",
    subscriptionSelectPlan: "Seleccionar",
    subscriptionIncluded: "Incluido",
    subscriptionOptionalAddon: "Opcional",
    subscriptionNotIncluded: "No incluido",
    subscriptionCatalogUnavailable: "Los planes no están disponibles temporalmente. Inténtelo de nuevo más tarde.",
    subscriptionNoPricingForCycle: "No disponible para este ciclo de facturación",
    subscriptionNoPlan: "Sin plan activo",
    subscriptionStatusActive: "Activo",
    subscriptionStatusTrial: "Prueba",
    subscriptionStatusPastDue: "Vencido",
    subscriptionStatusExpired: "Expirado",
    subscriptionStatusCancelled: "Cancelado",
    subscriptionPerMonth: "/mes",
    subscriptionPerYear: "/año",
    subscriptionEquivPerMonth: "/mes",
    subscriptionBilledPerYear: "Facturado {amount}/año",
    subscriptionSavingsPercent: "Ahorre {percent}%",
    featureComingSoon: "Próximamente",

    // Upgrade modal (F6)
    subscriptionUpgradePlan: "Cambiar de plan",
    subscriptionWhatsInPlan: "¿Qué incluye el plan {plan}?",
    subscriptionRecommended: "Recomendado",
    subscriptionFeatureRequiresUpgrade: "La función {feature} requiere un plan superior.",
    payrollAccessDeniedPlanRequired: "El módulo de nóminas no está incluido en su plan actual. Actualice para acceder a esta función.",
    subscriptionModalTitleChoose: "Elige tu plan",
    subscriptionModalTitleChange: "Cambiar de plan",
    subscriptionSubscribeAction: "Suscribirse",
    subscriptionSwitchTo: "Cambiar a {plan}",
    subscriptionDowngradeTo: "Bajar a {plan}",
    subscriptionFeaturesAdded: "Funcionalidades incluidas",
    subscriptionFeaturesRemoved: "Funcionalidades no incluidas",
    subscriptionSeeAllFeatures: "Ver todas las funcionalidades",
    subscriptionHideFeatures: "Ocultar funcionalidades",

    // First-choice flow (Lot 4)
    subscriptionChooseTitle: "Elige tu plan",
    subscriptionChooseSubtitle: "Selecciona un plan y complementos opcionales para comenzar.",
    subscriptionChooseConfirmTitle: "Confirma tu elección",
    subscriptionChooseConfirmText: "Vas a suscribirte al plan {plan} ({cycle}).",
    subscriptionChooseSuccess: "Tu plan ha sido activado",
    subscriptionChooseWithAddons: "con {count} complemento(s)",
    subscriptionPriceSummary: "Resumen del precio",
    subscriptionPlanPrice: "Plan ({plan})",
    subscriptionAddonsTotal: "Complementos",
    subscriptionSubtotalHT: "Subtotal sin IVA",
    subscriptionVatRate: "IVA ({rate} %)",
    subscriptionTotalTTC: "Total con IVA",
    subscriptionVatOnInvoiceNote: "Todos los precios se muestran sin IVA. El IVA aparecerá en su factura.",
    subscriptionConfirmChoice: "Confirmar y suscribirse",
    subscriptionWizardStepPlan: "Plan",
    subscriptionWizardStepAddons: "Complementos",
    subscriptionWizardStepSummary: "Resumen",
    subscriptionWizardNext: "Siguiente",
    subscriptionWizardBack: "Volver",
    subscriptionWizardConfirmAndPay: "Confirmar y pagar",
    subscriptionAddonsLoading: "Cargando complementos disponibles…",
    subscriptionAddonsLoadError: "No se pudieron cargar los complementos. Inténtelo de nuevo.",
    subscriptionAddonsIncompatibleRemoved: "Algunos complementos se eliminaron porque no son compatibles con el plan seleccionado.",
    subscriptionTotalHT: "Total sin IVA",
    subscriptionChangeTitle: "Cambiar de plan",
    subscriptionChangeSubtitle: "Selecciona un nuevo plan y complementos opcionales.",
    subscriptionWizardConfirmChange: "Confirmar el cambio",
    subscriptionConfirmedWaiting: "Su suscripci\u00f3n est\u00e1 confirmada. Estamos preparando su factura\u2026",
    subscriptionInvoiceReady: "Su factura est\u00e1 lista.",
    subscriptionTimeoutMessage: "Su suscripci\u00f3n est\u00e1 confirmada. Su factura estar\u00e1 disponible en breve en la pantalla de suscripci\u00f3n.",
    subscriptionDownloadingPdf: "Descargando\u2026",
    subscriptionPlanDenied: "Este plan no está disponible para tu cuenta.",
    subscriptionAddonBlocksChange: "Algunos complementos seleccionados no son compatibles con este plan. Deselecciónalos primero.",
    subscriptionSelectAddons: "Complementos opcionales",
    subscriptionNoAddonsSelected: "Ningún complemento seleccionado",
    subscriptionInvoiceNotice: "Se le enviará una factura {days} días antes del inicio de la suscripción.",
    subscriptionTrialUnchanged: "Su período de prueba gratuito permanece activo hasta el {date}.",
    subscriptionPaymentFlexible: "Cada factura podrá pagarse mediante QR-factura o tarjeta de crédito — usted elige en cada vencimiento.",
    subscriptionTermsLink: "Condiciones generales de venta",
    subscriptionRenewalNoticeMonthly: "Su suscripción se renovará automáticamente cada mes al precio de {amount} sin IVA, salvo cancelación previa.",
    subscriptionRenewalNoticeYearly: "Su suscripción se renovará automáticamente cada año al precio de {amount} sin IVA, salvo cancelación previa.",
    subscriptionCancellationNotice: "Puede cancelar su suscripción en cualquier momento desde esta página. La cancelación surte efecto al final del período en curso — conserva el acceso hasta esa fecha.",

    // Trial-aware billing disclosures (Lot 3)
    subscriptionInvoiceIssuedNow: "Su factura se emite de inmediato, a pagar antes del {date}.",
    subscriptionTrialUpgradeNotice: "Nuevo plan con efecto inmediato. Factura por la diferencia de {amount} sin IVA, a pagar antes del {date}.",
    subscriptionTrialUpgradeOperatorNotice: "Su primera factura será emitida a la tarifa de {plan}.",
    subscriptionTrialDowngradeNotice: "{plan} se aplicará a partir del {date}. Su primer período permanece en {currentPlan}.",
    subscriptionCancelResiliation: "Deshacer la cancelación",
    subscriptionCancelResiliationConfirmText: "Su suscripción continúa y la facturación se reanuda normalmente.",
    subscriptionErrorNothingToUndo: "No hay ninguna rescisión en curso que cancelar.",
    subscriptionCancelConfirmButton: "Sí, cancelar mi suscripción",
    subscriptionKeepSubscription: "Mantener mi suscripción",
    subscriptionEndingNotice: "Su suscripción terminará el {date}.",
    subscriptionAddonOnlyTrialNotice: "Las opciones seleccionadas son gratuitas hasta el final de su prueba el {date}. No se emitirá ninguna factura ahora.",
    subscriptionAddonOnlyProrataNotice: "Se generará una factura prorrateada por las opciones seleccionadas.",
    subscriptionAddonOnlySuccess: "Sus opciones han sido activadas con éxito.",
    subscriptionErrorPlanChoiceRequired: "Elija primero un plan antes de realizar cambios.",

    // Add-ons (F7 part C)
    addonSectionTitle: "Complementos",
    addonAvailable: "Disponible",
    addonActive: "Activo",
    addonPendingCancellation: "Activo — cancelación al final del período",
    addonActivate: "Activar",
    addonDeactivate: "Desactivar",
    addonActivateConfirmTitle: "¿Activar {name}?",
    addonActivateConfirmText: "Este complemento cuesta {price} y la facturación es inmediata. Se generará una factura prorrateada de inmediato. No es una prueba gratuita.",
    addonActivateConfirmTextTrial: "Este complemento es gratuito hasta el final de su prueba el {date}. No se emitirá ninguna factura ahora. Después de la prueba, se facturará a {price} junto con su plan.",
    addonActivateConfirmButton: "Activar ahora",
    addonActivatedSuccess: "{name} está ahora activo",
    addonActivatedInvoiceNotice: "La funcionalidad está disponible de inmediato. Una factura prorrateada seguirá en breve.",
    addonActivatedInvoiceNoticeTrial: "La funcionalidad está disponible de inmediato, sin costo hasta el {date}. La facturación comenzará con su plan.",
    addonDeactivateConfirmTitle: "¿Desactivar {name}?",
    addonDeactivateConfirmText: "El complemento permanecerá activo hasta el final del período actual ({date}). No se realizará ningún reembolso — la facturación se detiene al final del período.",
    addonDeactivateConfirmButton: "Desactivar al final del período",
    addonDeactivatedSuccess: "{name} se desactivará al final del período actual",
    addonAlreadyActive: "Este complemento ya está activo",
    addonIncompatible: "Este complemento no es compatible con su plan actual",
    addonNoPermission: "No tiene permiso para gestionar complementos. Contacte a su administrador.",
    addonActiveUntil: "Activo hasta {date}",
    addonBillingCycleMonthly: "al mes",
    addonBillingCycleYearly: "al año",
    addonBillingCycleOneTime: "único",
    addonNoneAvailable: "No hay complementos disponibles para su plan actual.",
    addonManageAddons: "Gestionar complementos",

    // Gated nav items — disabled tab tooltips
    navFeatureRequiresUpgrade: "Incluido en un plan superior",
    navFeatureAvailableAsAddon: "Disponible como opción",

    // Billing — invoices & payments (F3)
    billingInvoices: "Facturas",
    billingInvoiceNumber: "Número",
    billingInvoiceDate: "Fecha",
    billingInvoiceDueDate: "Vencimiento",
    billingInvoiceAmount: "Importe",
    billingInvoiceStatus: "Estado",
    billingInvoiceStatusOpen: "Abierta",
    billingInvoiceStatusPaid: "Pagada",
    billingInvoiceStatusVoid: "Anulada",
    billingInvoiceStatusDraft: "Borrador",
    billingInvoiceStatusUncollectible: "Incobrable",
    billingInvoiceOverdue: "Vencida",
    billingPay: "Pagar",
    billingDownloadPdf: "Descargar PDF",
    billingPaymentPending: "Pago en proceso…",
    billingPayments: "Pagos",
    billingPaymentDate: "Fecha",
    billingPaymentAmount: "Importe",
    billingPaymentMethod: "Método",
    billingPaymentResult: "Resultado",
    billingPaymentSucceeded: "Exitoso",
    billingPaymentFailed: "Fallido",
    billingPaymentRefunded: "Reembolsado",
    billingPaymentFailureReason: "Motivo",
    billingPaymentRetry: "Reintentar",
    billingPaymentMethods: "Métodos de pago",
    billingCardBrand: "Tarjeta",
    billingCardEnding: "terminada en {last4}",
    billingCardExpires: "Expira {month}/{year}",
    billingCardExpiringSoon: "Por expirar",
    billingCardDefault: "Predeterminado",
    billingAddPaymentMethod: "Agregar método de pago",
    billingDeletePaymentMethod: "Eliminar",
    billingDeleteMethodConfirmTitle: "¿Eliminar este método de pago?",
    billingDeleteMethodConfirmText: "Este método de pago se eliminará permanentemente.",
    billingDeleteDefaultMethodWarning: "Este es su método de pago predeterminado y el cobro automático está habilitado. Eliminarlo sin agregar otro hará que el próximo cargo falle.",
    billingMethodDeleted: "Método de pago eliminado",
    billingNoInvoices: "Aún no hay facturas",
    billingNoPayments: "Aún no hay pagos",
    billingNoPaymentMethods: "Sin métodos de pago registrados",
    billingUnavailable: "La información de facturación no está disponible temporalmente. Inténtelo de nuevo más tarde.",
    billingInvoiceDetail: "Detalle de factura",
    billingRelatedInvoice: "Factura",
    paymentTitle: "Pago",
    paymentCompany: "Empresa",
    paymentInvoiceNumber: "Factura",
    paymentAmount: "Importe",
    paymentDueDate: "Fecha de vencimiento",
    paymentExpiry: "Válido hasta",
    paymentPayNow: "Pagar ahora",
    paymentRedirecting: "Redirigiendo al proveedor de pago...",
    paymentLinkInvalid: "Este enlace de pago ya no es válido.",
    paymentLinkInvalidHint: "Contáctenos si cree que se trata de un error.",
    paymentLinkExpiredTitle: "Este enlace de pago ha expirado",
    paymentLinkExpiredDescription: "Este enlace ya no es válido. Vuelva a sus facturas para solicitar un nuevo enlace de pago.",
    paymentLinkExpiredAction: "Ir a mis facturas",
    paymentProcessing: "Procesando su pago...",
    paymentProcessingHint: "Espere mientras confirmamos su pago.",
    paymentSucceeded: "Pago exitoso",
    paymentSucceededHint: "Su pago ha sido procesado. Puede cerrar esta página.",
    paymentPending: "Pago en proceso",
    paymentPendingHint: "Su pago está siendo procesado. Recibirá una confirmación por correo electrónico en breve.",
    paymentFailed: "Pago fallido",
    paymentFailedHint: "Su pago no pudo ser procesado. Inténtelo de nuevo o contáctenos.",
    paymentCancelled: "Pago cancelado",
    paymentCancelledHint: "Ha cancelado el pago. No se ha cobrado ningún importe.",
    paymentStatusUnavailable: "Estado no disponible",
    paymentStatusUnavailableHint: "No pudimos recuperar el estado del pago. Verifique su correo electrónico para confirmación.",
    paymentRetry: "Reintentar el pago",
    paymentRetryExpired: "Este enlace de pago ha expirado. Solicite uno nuevo desde sus facturas.",
    paymentBackToSubscription: "Volver a mi suscripción",
    paymentRedirectingIn: "Redirigiendo en {0} s\u2026",
    paymentAmountPaid: "Importe pagado",
    paymentSignIn: "Iniciar sesión",
    paymentCheckAgain: "Verificar de nuevo",
    paymentNothingElseRequired: "Su factura ha sido pagada. No se requiere nada más.",
    billingAmountDue: "Importe pendiente",
    billingAmountDueCount: "{count} facturas",
    billingDueDate: "Vence el {date}",
    billingViewInvoices: "Ver facturas",
    billingPayAmount: "Pagar {amount}",
    addonStepTitle: "Añada opciones a su plan",
    addonStepHint: "Estas opciones son compatibles con su nuevo plan. También puede añadirlas más tarde.",
    addonStepSkip: "Omitir",
    addonStepDone: "Continuar",
    copy: "Copiar",
    copied: "Copiado",
    showQrCode: "Mostrar código QR",
    scanToAddMeAsContact: "Escanee este código desde la aplicación móvil para agregarme como contacto",
    myDigitalAdminCode: "Mi código Digital Admin",
    uuidTypeMismatch: "El tipo de UUID no coincide con el tipo de contacto (persona/empresa)",
    uuidNotLinked: "El contacto fue creado, pero el UUID proporcionado no corresponde a ningun usuario registrado",
    chatNoRegisteredContacts: "Sin contactos registrados",
    chatRegisteredContactsHint: "Sus contactos con una cuenta Digital Admin aparecen aqui",
    chatMembersUnavailable: "Esta empresa no expone a sus miembros",
    chatSelectContact: "Seleccionar un contacto",
    chatStartNewConversation: "Iniciar una conversacion",
    manualEntryMatchesWarning: "Documentos o pagos corresponden a esta línea bancaria. Prefiera la conciliación desde la lista de correspondencias.",
    viewMatches: "Ver correspondencias",
    directChargeWarning: "Está registrando un gasto directo. Si este movimiento paga una factura de proveedor existente, utilice la conciliación para no contabilizar el gasto dos veces.",
    directRevenueWarning: "Está registrando un ingreso directo. Si este movimiento cobra una factura de cliente existente, utilice la conciliación para no contabilizar el ingreso dos veces.",

    // Assets (rental inventory)
    assets: "Activos",
    asset: "Activo",
    createAsset: "Crear activo",
    editAsset: "Editar activo",
    listAssets: "Lista de activos",
    viewAsset: "Ver activo",
    assetName: "Nombre del activo",
    assetCode: "Código",
    assetDescription: "Descripción",
    defaultDepositAmount: "Depósito por defecto",
    acquisitionValue: "Valor de adquisición",
    acquisitionDate: "Fecha de adquisición",
    isDepreciable: "Amortizable",
    residualValue: "Valor residual",
    depreciationYears: "Periodo de amortización (años)",
    depreciationSection: "Amortización",
    assetStatusAvailable: "Disponible",
    assetStatusRented: "Alquilado",
    assetStatusOutOfService: "Fuera de servicio",
    currentTenant: "Inquilino actual",
    rentedSince: "Alquilado desde",
    rentedUntil: "Alquilado hasta",
    searchAsset: "Buscar activo",
    youWantToDeleteTheAsset: "¿Desea eliminar este activo?",
    assetDeletedSuccess: "Activo eliminado",
    assetCreatedSuccess: "Activo creado",
    assetUpdatedSuccess: "Activo actualizado",
    assetStatusManagedByRental: "El estado es gestionado por eventos de alquiler",
    noAssetsFound: "No se encontraron activos",
    rentAsset: "Alquilar",
    rentThisAsset: "Alquilar este activo",
    tenant: "Inquilino",
    rentalCadence: "Frecuencia de facturación",
    rentalStart: "Fecha de inicio",
    rentalEnd: "Fecha de fin",
    rentalDepositAmount: "Depósito de garantía",
    confirmRental: "Confirmar alquiler",
    rentalCreatedSuccess: "Contrato de alquiler creado",
    cadenceMonthly: "Mensual",
    cadenceQuarterly: "Trimestral",
    cadenceAnnual: "Anual",
    cadenceDay: "Dia",
    cadenceWeek: "Semana",
    cadenceMonth: "Mes",
    cadenceQuarter: "Trimestre",
    cadenceYear: "Ano",
    rentalOptions: "Opciones de alquiler",
    addRentalOption: "Agregar opcion de alquiler",
    selectService: "Seleccionar un servicio",
    rentalOption: "Opcion de alquiler",
    selectRentalOption: "Seleccionar una opcion de alquiler",
    noRentalOptionConfigured: "Este bien no tiene opciones de alquiler configuradas.",
    noRentalOption: "Sin opcion de alquiler",

    // Security deposit (caution)
    securityDeposit: "Depósito de garantía",
    depositAmount: "Monto del depósito",
    depositStatus: "Estado del depósito",
    depositNone: "Ninguno",
    depositPending: "Pendiente",
    depositReceived: "Recibido",
    depositPartiallyRetained: "Parcialmente retenido",
    depositReturned: "Devuelto",
    receiveDeposit: "Registrar la recepción",
    returnDeposit: "Devolver el depósito",
    retainedAmount: "Monto retenido",
    returnedAmount: "Monto devuelto",
    retainedAmountHint: "Monto retenido por daños",
    amountToReturn: "Monto a devolver",
    depositReceivedSuccess: "Recepción del depósito registrada",
    depositReturnedSuccess: "Depósito devuelto",
    receivedAt: "Recibido el",
    returnedAt: "Devuelto el",
    depositMethod: "Método de pago",
    depositNote: "Nota",

    // Expense reports
    expenseReports: "Notas de gastos",
    expenseReport: "Nota de gastos",
    expenseReportNumber: "N° de nota",
    listExpenseReports: "Lista de notas de gastos",
    createExpenseReport: "Crear nota de gastos",
    editExpenseReport: "Editar nota de gastos",
    viewExpenseReport: "Ver nota de gastos",
    updateExpenseReport: "Actualizar nota de gastos",
    submitted: "Enviada",
    validated: "Validada",
    submitExpenseReport: "Enviar",
    rejectExpenseReport: "Devolver para corrección",
    validateExpenseReport: "Validar nota de gastos",
    rejectionReason: "Motivo del rechazo",
    rejectionReasonPlaceholder: "Ingrese el motivo del rechazo...",
    rejectionReasonRequired: "Un motivo de rechazo es obligatorio",
    rejectedReason: "Motivo del rechazo",
    reimburse: "Reembolsar",
    createReimbursement: "Crear reembolso",
    createNewReimbursementForExpenseReport: "Crear nuevo reembolso para nota de gastos",
    employee: "Empleado",
    merchant: "Comerciante",
    expenseDate: "Fecha del gasto",
    youWantToDeleteThisExpenseReport: "¿Desea eliminar esta nota de gastos?",
    processOfCreatingANewExpenseReportCompleted: "Proceso de creación de una nueva nota de gastos completado.",
    ifYouWantToSaveTheNewExpenseReport: "si desea guardar la nueva nota de gastos.",
    processOfUpdatingAnExpenseReportCompleted: "Proceso de actualización de una nota de gastos completado.",
    thisExpenseReportHasNoPayments: "Esta nota de gastos no tiene reembolsos.",
    youWantToSubmitThisExpenseReport: "¿Desea enviar esta nota de gastos?",
    expenseReportSubmittedSuccessfully: "Nota de gastos enviada con éxito.",
    youWantToValidateThisExpenseReport: "¿Desea validar esta nota de gastos?",
    youWantToInvalidateThisExpenseReport: "Si invalida esta nota de gastos, las entradas contables asociadas serán eliminadas.",
    iban: "IBAN",
    receipt: "Recibo",
    attachReceipt: "Adjuntar recibo",
    removeReceipt: "Eliminar recibo",
    expenseLineDetails: "Detalles de la línea de gasto",
    newExpenseReport: "Nuevo informe de gastos",
    descriptionCreateExpenseReport: "Por favor, ingrese los siguientes datos, son necesarios para crear un nuevo informe de gastos.",
    pleaseModifyFieldsFromExpenseReport: "Modifique, agregue y/o elimine los campos que desee del informe de gastos.",
    selectAnEmployee: "Seleccionar un empleado",
    beforeCreatingExpenseReport: "Antes de crear el informe de gastos",
    wouldYouLikeUploadPdfFilesToExpenseReport: "¿Desea subir archivos PDF para el nuevo informe de gastos?",
    whenYouUploadPdfFilesTheyArePlacedAsExpenseReportLines: "Cuando sube archivos PDF, se colocan como adjuntos de recibo en cada línea de gasto del formulario de creación.",
    expenseBelongsToExpenseReport: "Este gasto pertenece al informe de gastos",
    expenseManagedFromReport: "Se edita y valida desde el informe de gastos.",

    // Write-off (dar de baja por pérdida)
    chargedOff: "Dada de baja por pérdida",
    writeOff: "Dar de baja por pérdida",
    writeOffInvoice: "Dar de baja la factura por pérdida",
    writeOffAmount: "Importe a dar de baja",
    writeOffDate: "Fecha de la baja",
    writeOffLossAccount: "Cuenta de pérdidas",
    writeOffReason: "Motivo",
    writeOffReasonRequired: "Se requiere un motivo",
    writeOffConfirmMessage: "Esta factura será dada de baja por pérdida de",
    writeOffVatCorrectionMessage: "El IVA de {amount} será corregido (cifra 235).",
    writeOffSuccess: "Factura dada de baja por pérdida con éxito",
    writeOffCancelConfirm: "¿Desea cancelar esta baja por pérdida?",
    writeOffCancelSuccess: "Baja por pérdida cancelada con éxito",
    writeOffs: "Bajas por pérdida",
    writeOffAmountExceedsDebt: "El importe supera la deuda restante",
    invoiceAlreadyChargedOff: "Esta factura ya fue dada de baja por pérdida",

    // Expense access (employee)
    expenseAccess: "Acceso a notas de gastos",
    expenseAccessAuto: "Automático (según el estado)",
    expenseAccessForcedOn: "Siempre autorizado",
    expenseAccessForcedOff: "Nunca autorizado",
    expenseAccessHelp: "Automático: autorizado si el empleado está en curso de empleo (borrador o activo). Siempre/Nunca: fuerzan el acceso independientemente del estado.",
  },
};
